<template>
  <page>
    <v-layout row wrap>
      <v-flex xs12>
        <v-card>
          <v-card-text>
            <v-tabs v-model="key" icons-and-text :touchless="true">
              <v-tab icons-and-text v-for="(ttyStmtTab, x) in ttyStmtTabs" :key="x" :disabled="(x == 1 && key == 0 && newMode) || (x == 1 && key == 0 && !checkTtyStmtLnList)">
                {{ ttyStmtTab }}
              </v-tab>
            </v-tabs>
            <v-tabs-items v-model="key">
              <v-tab-item :key="0">
                <v-flex>
                  <v-toolbar dense color="grey lighten-5" flat>
                    <v-icon>mdi-format-align-justify</v-icon>
                    <v-toolbar-title class="toolbar-title-3" v-if="reviewMode">Update Treaty Statement</v-toolbar-title>
                    <v-toolbar-title class="toolbar-title-3" v-else-if="queryMode">Query Treaty Statement</v-toolbar-title>
                    <v-toolbar-title class="toolbar-title-3" v-else>New Treaty Statement</v-toolbar-title>
                  </v-toolbar>
                  <v-container fluid grid-list-lg>
                  <v-layout row wrap>
                    <v-flex xs12>
                      <message :messages="messages"></message>
                      <v-container fluid grid-list-lg>
                        <!-- Row 1 -->
                        <v-layout row wrap>
                          <v-flex xs6 md6 lg4 v-if="queryMode">
                            <v-subheader class="queryLabel">{{ labels.ttyRef }}</v-subheader>
                            <div class="queryValue">{{ ttyHeaderForm.ttyRef }}</div>
                          </v-flex>
                          <v-flex xs6 md6 lg4 v-else>
                            <v-text-field
                              v-model="ttyHeaderForm.ttyRef"
                              v-validate="checkTtyRefValidation"
                              :label="labels.ttyRef"
                              data-vv-name="ttyRef"
                              :data-vv-as="labels.ttyRef"
                              :error-messages="errors.collect('ttyRef')"
                              @change="checkTtyRef()"
                              :disabled="reviewMode"
                            >
                              <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                                <v-icon color="info" @click="getHelpList('ttyRef')" v-text="'mdi-magnify'"></v-icon>
                              </v-slide-x-reverse-transition>
                            </v-text-field>
                          </v-flex>
                          <v-flex xs6 md6 lg4 v-if="queryMode">
                            <v-subheader class="queryLabel">{{ labels.ttyDesc }}</v-subheader>
                            <div class="queryValue">{{ ttyHeaderForm.ttyDesc }}</div>
                          </v-flex>
                          <v-flex xs6 md6 lg4 v-else>
                            <v-text-field
                              v-model="ttyHeaderForm.ttyDesc"
                              v-validate="'required'"
                              :label="labels.ttyDesc"
                              item-text="label"
                              item-value="value"
                              data-vv-name="ttyDesc"
                              :error-messages="errors.collect('ttyDesc')"
                              :data-vv-as="labels.ttyDesc"
                              readonly
                              :disabled="reviewMode"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs6 sm4 md3 xl2>
                            <v-text-field
                              v-model="ttyHeaderForm.tranRef"
                              :label="labels.tranRef"
                              :error-messages="errors.collect('ttyHeaderForm.tranRef')"
                              data-vv-name="ttyHeaderForm.tranRef"
                              :data-vv-as="ttyHeaderForm.tranRef"
                              v-validate="'entry'"
                              :disabled="true"
                            ></v-text-field>
                          </v-flex>
                        </v-layout>
                        <!-- Row 2 -->
                        <v-layout row wrap>
                          <v-flex xs6 md6 lg4 v-if="queryMode">
                            <v-subheader class="queryLabel">{{ labels.cedBrk }}</v-subheader>
                            <div class="queryValue">{{ ttyHeaderForm.cedBrkDesc }}</div>
                          </v-flex>
                          <v-flex xs6 md6 lg4 v-else>
                            <v-text-field
                              v-model="ttyHeaderForm.cedBrk"
                              v-validate="checkCedBrkValidation"
                              :label="labels.cedBrk"
                              data-vv-name="ttyHeaderForm.cedBrk"
                              :data-vv-as="labels.cedBrk"
                              :error-messages="errors.collect('ttyHeaderForm.cedBrk')"
                              @change="checkCedBrk('cedBrk')"
                            >
                              <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                                <v-icon color="info" @click="getHelpList('cedBrk')" v-text="'mdi-magnify'"></v-icon>
                              </v-slide-x-reverse-transition>
                            </v-text-field>
                          </v-flex>
                          <v-flex xs6 md6 lg4 v-if="queryMode">
                            <v-subheader class="queryLabel">{{ labels.cedCo }}</v-subheader>
                            <div class="queryValue">{{ ttyHeaderForm.cedCo }}</div>
                          </v-flex>
                          <v-flex xs6 md6 lg4 v-else>
                            <v-text-field
                              v-model="ttyHeaderForm.cedCo"
                              v-validate="checkCedCoValidation"
                              :label="labels.cedCo"
                              data-vv-name="cedCo"
                              :data-vv-as="labels.cedCo"
                              :error-messages="errors.collect('cedCo')"
                              @change="checkCedBrk('cedCo')"
                            >
                              <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                                <v-icon color="info" @click="getHelpList('cedCo')" v-text="'mdi-magnify'"></v-icon>
                              </v-slide-x-reverse-transition>
                            </v-text-field>
                          </v-flex>
                        </v-layout>
                        <!-- Row 3 -->
                        <v-layout row wrap>
                          <v-flex xs6 md6 lg4 v-if="queryMode">
                            <v-subheader class="queryLabel">{{ labels.stmtType }}</v-subheader>
                            <div class="queryValue">{{ ttyHeaderForm.stmtType }}</div>
                          </v-flex>
                          <v-flex xs6 md6 lg4 v-else>
                            <v-autocomplete
                              v-model="ttyHeaderForm.stmtType"
                              v-validate="'required'"
                              :items="stmtTypeList"
                              :label="labels.stmtType"
                              item-text="label"
                              item-value="value"
                              data-vv-name="stmtType"
                              :error-messages="errors.collect('stmtType')"
                              :data-vv-as="labels.stmtType"
                              :disabled="this.ttyHeaderForm.ttyRef === undefined || this.ttyHeaderForm.ttyRef === '' || reviewMode"
                              @change="assignAllRI(ttyHeaderForm.stmtType)"
                            ></v-autocomplete>
                          </v-flex>
                          <v-flex xs6 md6 lg4 v-if="queryMode">
                            <v-subheader class="queryLabel">{{ labels.stmtRef }}</v-subheader>
                            <div class="queryValue">{{ ttyHeaderForm.stmtRef }}</div>
                          </v-flex>
                          <v-flex xs6 md6 lg4 v-else>
                            <v-text-field
                              v-model="ttyHeaderForm.stmtRef"
                              v-validate="'entry'"
                              :label="labels.stmtRef"
                              item-text="label"
                              item-value="value"
                              data-vv-name="stmtRef"
                              :error-messages="errors.collect('stmtRef')"
                              :data-vv-as="labels.stmtRef"
                              :disabled="queryMode"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs6 sm4 md3 xl2 v-if="false">
                            <v-text-field
                              v-model="ttyHeaderForm.uwYr"
                              :label="labels.uwYr"
                              :error-messages="errors.collect('ttyHeaderForm.uwYr')"
                              data-vv-name="ttyHeaderForm.uwYr"
                              :data-vv-as="ttyHeaderForm.uwYr"
                              v-validate="'entry'"
                              readonly
                              :disabled="reviewMode"
                            ></v-text-field>
                          </v-flex>
                        </v-layout>
                        <!-- Row 4 -->
                        <v-layout row wrap>
                          <v-flex xs12 md5 lg4>
                            <cal-picker
                              v-model="ttyHeaderForm.tranDate"
                              v-validate="checkTranDateValidation"
                              :label="labels.tranDate"
                              :data-vv-as="labels.tranDate"
                              data-vv-name="tranDate"
                              :error-messages="errors.collect('tranDate')"
                              @blur="checkTranDate"
                              :disabled="queryMode || reviewMode"
                            ></cal-picker>
                          </v-flex>
                          <v-flex xs6 sm4 md2 xl2>
                            <v-text-field
                              v-model="ttyHeaderForm.acctMth"
                              :label="labels.acctMth"
                              :error-messages="errors.collect('ttyHeaderForm.acctMth')"
                              data-vv-name="ttyHeaderForm.acctMth"
                              :data-vv-as="ttyHeaderForm.acctMth"
                              v-validate="'entry'"
                              :disabled="true"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs6 sm4 md2 xl2>
                            <v-text-field
                              v-model="ttyHeaderForm.acctYr"
                              :label="labels.acctYr"
                              :error-messages="errors.collect('ttyHeaderForm.acctYr')"
                              data-vv-name="ttyHeaderForm.acctYr"
                              :data-vv-as="ttyHeaderForm.acctYr"
                              v-validate="'entry'"
                              :disabled="true"
                            ></v-text-field>
                          </v-flex>
                        </v-layout>
                        <!-- Row 5 -->
                        <v-layout>
                          <v-flex xs6 md6 lg4 v-if="queryMode">
                            <v-subheader class="queryLabel">{{ labels.debtType }}</v-subheader>
                            <div class="queryValue">{{ ttyHeaderForm.debtType }}</div>
                          </v-flex>
                          <!-- SSY 20220321: OK-545 Part 2 (2.0) -->
                          <!-- <v-flex xs6 md6 lg4 v-else>
                            <v-autocomplete
                              v-model="ttyHeaderForm.debtType"
                              v-validate="checkDebtTypeValidation"
                              :items="debtTypeList"
                              :label="labels.debtType"
                              item-text="label"
                              item-value="value"
                              data-vv-name="debtType"
                              :error-messages="errors.collect('debtType')"
                              :data-vv-as="labels.debtType"
                              :disabled="this.ttyHeaderForm.riType === 'I'"
                            ></v-autocomplete>
                          </v-flex> -->
                          <v-flex xs6 md6 lg4 v-else>
                            <v-autocomplete
                              v-model="ttyHeaderForm.debtType"
                              :items="debtTypeList"
                              :label="labels.debtType"
                              item-text="label"
                              item-value="value"
                              data-vv-name="debtType"
                              :error-messages="errors.collect('debtType')"
                              :data-vv-as="labels.debtType"
                              readonly
                            ></v-autocomplete>
                          </v-flex>
                          <!-- <v-flex xs6 md6 lg4 v-if="this.ttyHeaderForm.riType === 'O'"> -->
                          <!-- <v-flex xs6 md6 lg4 v-if="queryMode && this.ttyHeaderForm.riType === 'O'">
                              <v-subheader class="queryLabel">{{labels.allRI}}</v-subheader>
                              <div class="queryValue">{{ttyHeaderForm.allRI}}</div>
                            </v-flex> -->
                          <v-flex xs6 md6 lg4 v-if="this.ttyHeaderForm.riType === 'O'">
                            <v-autocomplete
                              v-model="ttyHeaderForm.allRI"
                              v-validate="'required'"
                              :items="allRIList"
                              :label="labels.allRI"
                              item-text="label"
                              item-value="value"
                              data-vv-name="allRI"
                              :error-messages="errors.collect('allRI')"
                              :data-vv-as="labels.allRI"
                              :disabled="queryMode"
                            ></v-autocomplete>
                          </v-flex>
                          <!-- </v-flex> -->
                          <!-- <v-flex xs6 md6 lg4 v-else> -->
                          <v-flex xs6 md6 lg4 v-if="queryMode && this.ttyHeaderForm.riType === 'I'">
                            <v-subheader class="queryLabel">{{ labels.allRet }}</v-subheader>
                            <div class="queryValue">{{ ttyHeaderForm.allRI }}</div>
                          </v-flex>
                          <v-flex xs6 md6 lg4 v-else-if="!queryMode && this.ttyHeaderForm.riType === 'I'">
                            <v-autocomplete
                              v-model="ttyHeaderForm.allRI"
                              v-validate="'required'"
                              :items="allRIList"
                              :label="labels.allRet"
                              item-text="label"
                              item-value="value"
                              data-vv-name="allRI"
                              :error-messages="errors.collect('allRI')"
                              :data-vv-as="labels.allRI"
                            ></v-autocomplete>
                          </v-flex>
                          <!-- </v-flex> -->
                          <v-flex xs6 sm4 md3 xl2>
                            <v-checkbox color="primary" :label="labels.stmtPrt" v-model="ttyHeaderForm.stmtPrt" :disabled="true"></v-checkbox>
                          </v-flex>
                        </v-layout>
                        <!-- Row 6 -->
                        <v-layout>
                          <v-flex xs12 md4 lg4>
                            <cal-picker
                              v-model="ttyHeaderForm.acctPerStDate"
                              v-validate="'required'"
                              :label="labels.acctPerStDate"
                              :data-vv-as="labels.acctPerStDate"
                              data-vv-name="acctPerStDate"
                              :error-messages="errors.collect('acctPerStDate')"
                              @change="checkAcctPerStDate"
                              :disabled="queryMode"
                            ></cal-picker>
                          </v-flex>
                          <v-flex xs12 md4 lg4>
                            <cal-picker
                              v-model="ttyHeaderForm.acctPerEndDate"
                              v-validate="checkAcctPerEndDateValidation"
                              :label="labels.acctPerEndDate"
                              :data-vv-as="labels.acctPerEndDate"
                              data-vv-name="acctPerEndDate"
                              :error-messages="errors.collect('acctPerEndDate')"
                              @blur="checkAcctPerEndDate"
                              :disabled="queryMode"
                            ></cal-picker>
                          </v-flex>
                          <v-flex xs6 sm4 md3 xl2 v-if="false">
                            <v-text-field
                              v-model="ttyHeaderForm.ttyYr"
                              :label="labels.ttyYr"
                              :error-messages="errors.collect('ttyHeaderForm.ttyYr')"
                              data-vv-name="ttyHeaderForm.ttyYr"
                              :data-vv-as="ttyHeaderForm.ttyYr"
                              v-validate="'entry'"
                              readonly
                              :disabled="reviewMode"
                            ></v-text-field>
                          </v-flex>
                        </v-layout>
                        <!-- Row 7 -->
                        <v-layout>
                          <v-flex xs6 md6 lg4 v-if="queryMode">
                            <v-subheader class="queryLabel">{{ labels.curr }}</v-subheader>
                            <div class="queryValue">{{ ttyHeaderForm.curr }}</div>
                          </v-flex>
                          <v-flex xs6 md6 lg4 v-else>
                            <v-text-field
                              v-model="ttyHeaderForm.curr"
                              v-validate="'required'"
                              :label="labels.curr"
                              data-vv-name="curr"
                              :data-vv-as="labels.curr"
                              :error-messages="errors.collect('curr')"
                            >
                              <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                                <v-icon color="info" @click="showCurrencyHelpList = true" v-text="'mdi-magnify'"></v-icon>
                              </v-slide-x-reverse-transition>
                            </v-text-field>
                          </v-flex>
                          <v-flex xs6 md4 lg4>
                            <v-layout row wrap>
                              <v-flex xs2 md1 lg1>
                                <v-checkbox
                                  left
                                  color="primary"
                                  v-model="ttyHeaderForm.currRateAE"
                                  :disabled="queryMode"
                                  @change="doProcessCommission(ttyHeaderForm.currRateAE)"
                                ></v-checkbox>
                              </v-flex>
                              <v-flex xs8 md8 lg9 v-if="queryMode">
                                <v-subheader class="queryLabel">{{ labels.currRate }}</v-subheader>
                                <div class="queryValue">{{ ttyHeaderForm.currRate }}</div>
                              </v-flex>
                              <v-flex xs8 md8 lg9 v-else>
                                <v-text-field
                                  v-model="ttyHeaderForm.currRate"
                                  v-num-mask="{ negative: true, intScale: 18, decScale: 6 }"
                                  :label="labels.currRate"
                                  :data-vv-as="labels.currRate"
                                  v-validate="'required'"
                                  data-vv-name="currRate"
                                  :error-messages="errors.collect('currRate')"
                                  :disabled="ttyHeaderForm.currRateAE"
                                ></v-text-field>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                          <v-flex xs6 sm4 md2 xl2>
                            <v-autocomplete
                              :items="instalNoList"
                              v-model="ttyHeaderForm.instalNo"
                              :label="labels.instalNo"
                              item-text="label"
                              item-value="value"
                              data-vv-name="ttyHeaderForm.instalNo"
                              :data-vv-as="labels.instalNo"
                              :error-messages="errors.collect('instalNo')"
                              v-validate="'required'"
                              :disabled="queryMode"
                            ></v-autocomplete>
                            <!-- <v-text-field v-model="ttyHeaderForm.instalNo" :label="labels.instalNo" :error-messages="errors.collect('instalNo')" data-vv-name="instalNo" :data-vv-as="labels.instalNo" v-validate="'required'"></v-text-field> -->
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-flex>
                  </v-layout>
                  </v-container>
                </v-flex>
                <v-flex xs12>
                  <v-card-actions>
                    <v-btn color="error" dark class="mb-2" @click.prevent="doCancel">Cancel<v-icon dark right>mdi-cancel</v-icon></v-btn>
                    <v-btn v-if="newMode || reviewMode" color="primary" dark class="mb-2" @click="doSave" :loading="submitting">
                      Save
                      <v-icon right>mdi-content-save</v-icon>
                    </v-btn>
                    <v-btn v-if="newMode || reviewMode" color="primary" dark class="mb-2" @click="doProceed" :loading="(!checkTtyStmtLnList && loading)">
                      Proceed
                      <v-icon right>mdi-arrow-right-bold-box</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn v-if="ttyStmtLnTop1Found || reviewMode" color="primary" dark @click.prevent="doRelease">
                      {{ labels.release }}
                      <v-icon dark right>mdi-arrow-right-bold-box</v-icon>
                    </v-btn>
                  </v-card-actions>
                </v-flex>
              </v-tab-item>
              <v-tab-item :key="1">
                <v-card>
                  <v-flex class="text-right">
                    <v-layout row wrap>
                      <v-subheader class="ma-3">Retrocessionaire / Reinsurer Ref</v-subheader>
                      <v-flex xs6 md5 lg3>
                        <v-select
                          v-model="ttyStmtLnForm.retroRiRef"
                          :items="retroRIList"
                          :label="ttyStmtLnlabels.retroRiRef"
                          item-text="text"
                          item-value="value"
                          clearable
                          @change="getTtyStmtLnListByRetroRiRef()"
                        />
                      </v-flex>
                      <v-flex xs4 md3 lg2 ml-3>
                        <v-select
                          v-model="ttyStmtLnForm.retroRiRefUwYr"
                          :items="retroRIUwYrList"
                          :label="labels.retroRiRefUwYr"
                          item-text="text"
                          item-value="value"
                          data-vv-name="retroRiRefUwYr"
                          :error-messages="errors.collect('retroRiRefUwYr')"
                          :data-vv-as="labels.retroRiRefUwYr"
                          clearable
                          @change="getTtyStmtLnListByRetroRiRefUwYr()"
                        />
                      </v-flex>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" v-if="(!queryMode && ttyStmtLnForm.retroRiRef === '')" @click.native="doNew()" class="ma-4">
                        <span>New Treaty Statement Line</span>
                        <v-icon right dark>mdi-plus</v-icon>
                      </v-btn>
                      <v-menu offset-x :nudge-left="370" :close-on-content-click="false" :min-width="300" :max-height="400">
                        <template v-slot:activator="{ on }">
                          <v-btn color="secondary" class="white--text && ma-4" v-on="on">
                            <span>Columns</span>
                            <v-icon right dark>mdi-table-column-plus-after</v-icon>
                          </v-btn>
                        </template>
                        <v-card>
                          <v-card-text>
                            <template v-if="columns.length > 0">
                              <v-checkbox
                                v-for="column in columns"
                                :key="column.value"
                                :label="column.text"
                                :value="column.value"
                                v-model="selectedTtyStmtLnColumns"
                              ></v-checkbox>
                            </template>
                            <template v-else>No column found</template>
                          </v-card-text>
                        </v-card>
                      </v-menu>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12>
                    <v-card>
                      <v-data-table
                        :headers="listTtyStmtLn"
                        :items="ttyStmtLnList"
                        :server-items-length="totalItemsTtyStmtLn"
                        :footer-props="{'items-per-page-options': itemsPerPage }"
                        v-bind:options.sync="paginationTtyStmtLn"
                        item-key="key"
                        :loading="loading"
                        :no-data-text="noDataText"
                      >
                        <!-- <v-data-table :headers="listTtyStmtLn" :items="ttyStmtLnList"> -->
                        <template v-slot:item="row">
                          <tr>
                            <td v-for="column in selectedTtyStmtLnColumns" :key="column">{{ row.item[column] }}</td>
                            <!-- <td class="text-xs-left">{{ row.item.riRef }}</td> -->
                            <td class="table-action-header">
                              <table-action
                                v-if="!queryMode && ttyStmtLnForm.retroRiRef === ''"
                                :rowData="row"
                                review
                                @review="doReviewTtyStmtLn(row.item)"
                                query
                                @query="doQueryTtyStmtLn(row.item)"
                                remove
                                @remove="doPromptRemoveTtyStmtLn(row.item)"
                                :loading="loading"
                              ></table-action>
                              <table-action
                                v-else-if="!queryMode && ttyStmtLnForm.retroRiRef !== ''"
                                :rowData="row"
                                review
                                @review="doReviewTtyStmtLn(row.item)"
                                query
                                @query="doQueryTtyStmtLn(row.item)"
                                :loading="loading"
                              ></table-action>
                              <table-action v-else :rowData="row" query @query="doQueryTtyStmtLn(row.item)" :loading="loading"></table-action>
                            </td>
                          </tr>
                        </template>
                      </v-data-table>
                    </v-card>
                  </v-flex>
                  <v-card-text v-if="showTtyStmtLn">
                    <v-toolbar dense color="grey lighten-3" flat>
                      <v-icon v-if="newMode">mdi-plus</v-icon>
                      <v-icon v-else-if="reviewMode">mdi-pencil</v-icon>
                      <v-icon v-else-if="queryMode">mdi-magnify</v-icon>
                      <v-toolbar-title v-if="newModeTtyStmtLn">Create Treaty Statement Line</v-toolbar-title>
                      <v-toolbar-title v-else-if="reviewModeTtyStmtLn">Edit Treaty Statement Line</v-toolbar-title>
                      <v-toolbar-title v-else-if="queryModeTtyStmtLn">View Treaty Statement Line</v-toolbar-title>
                    </v-toolbar>
                    <v-container fluid grid-list-lg>
                      <!-- Row 1 -->
                      <v-layout row wrap>
                        <v-flex xs6 md6 lg4 v-if="(queryModeTtyStmtLn || reviewModeTtyStmtLn)">
                          <v-subheader class="queryLabel">{{ ttyStmtLnlabels.riRef }}</v-subheader>
                          <div class="queryValue">{{ ttyStmtLnForm.riRef }}</div>
                        </v-flex>
                        <v-flex xs6 md6 lg4 v-else>
                          <v-text-field
                            v-model="ttyStmtLnForm.riRef"
                            :label="ttyStmtLnlabels.riRef"
                            :data-vv-as="ttyStmtLnlabels.riRef"
                            v-validate="riBrkRefCheck"
                            data-vv-name="riRef"
                            :error-messages="errors.collect('riRef')"
                            :disabled="this.mode === 'query' || !newModeTtyStmtLn"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs6 md6 lg4 v-if="(queryModeTtyStmtLn || reviewModeTtyStmtLn)">
                          <v-subheader class="queryLabel">{{ ttyStmtLnlabels.acctNoSfx }}</v-subheader>
                          <div class="queryValue">{{ ttyStmtLnForm.acctNoSfx }}</div>
                        </v-flex>
                        <v-flex xs6 md6 lg4 v-else>
                          <v-text-field
                            v-model="ttyStmtLnForm.acctNoSfx"
                            :label="ttyStmtLnlabels.acctNoSfx"
                            :data-vv-as="ttyStmtLnlabels.acctNoSfx"
                            v-validate="'entry'"
                            data-vv-name="acctNoSfx"
                            :error-messages="errors.collect('acctNoSfx')"
                          ></v-text-field>
                        </v-flex>
                        <!-- <v-container fluid grid-list-lg>
                          <v-layout row wrap>
                          </v-layout>
                        </v-container> -->
                      </v-layout>
                      <!-- Row 2 -->
                      <v-layout row wrap>
                        <v-flex xs6 md6 lg4 v-if="queryModeTtyStmtLn || reviewModeTtyStmtLn">
                          <v-subheader class="queryLabel">{{ ttyStmtLnlabels.brkRef }}</v-subheader>
                          <div class="queryValue">{{ ttyStmtLnForm.brkRef }}</div>
                        </v-flex>
                        <v-flex xs6 md6 lg4 v-else>
                          <v-text-field
                            v-model="ttyStmtLnForm.brkRef"
                            :label="ttyStmtLnlabels.brkRef"
                            :data-vv-as="ttyStmtLnlabels.brkRef"
                            v-validate="riBrkRefCheck"
                            data-vv-name="brkRef"
                            :error-messages="errors.collect('brkRef')"
                            :disabled="this.mode === 'query' || !newModeTtyStmtLn"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs6 md6 lg4 v-if="(queryModeTtyStmtLn || reviewModeTtyStmtLn)">
                          <v-subheader class="queryLabel">{{ ttyStmtLnlabels.brkAcctNoSfx }}</v-subheader>
                          <div class="queryValue">{{ ttyStmtLnForm.brkAcctNoSfx }}</div>
                        </v-flex>
                        <v-flex xs6 md6 lg4 v-else>
                          <v-text-field
                            v-model="ttyStmtLnForm.brkAcctNoSfx"
                            :label="ttyStmtLnlabels.brkAcctNoSfx"
                            :data-vv-as="ttyStmtLnlabels.brkAcctNoSfx"
                            v-validate="'entry'"
                            data-vv-name="brkAcctNoSfx"
                            :error-messages="errors.collect('brkAcctNoSfx')"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs6 md6 lg2>
                          <v-text-field
                            v-model="ttyStmtLnForm.uwYr"
                            :label="ttyStmtLnlabels.uwYr"
                            :error-messages="errors.collect('ttyStmtLnForm.uwYr')"
                            data-vv-name="ttyStmtLnForm.uwYr"
                            :data-vv-as="ttyStmtLnForm.uwYr"
                            v-validate="'entry'"
                            readonly
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                      <!-- Row 3 -->
                      <v-layout row wrap>
                        <v-flex xs12>
                          <v-subheader class="queryLabel">{{ ttyStmtLnlabels.cedCoCedBrk }}</v-subheader>
                          <div class="queryValue">{{ ttyStmtLnForm.cedCo }}</div>
                        </v-flex>
                      </v-layout>
                      <!-- Row 4 -->
                      <v-layout row wrap v-if="this.ttyHeaderForm.riType === 'I'">
                        <v-flex xs12>
                          <v-subheader class="queryLabel">{{ ttyStmtLnlabels.sharePctOffShares }}</v-subheader>
                          <div class="queryValue">{{ ttyStmtLnForm.sharePctOff }} / {{ ttyStmtLnForm.shares }}</div>
                        </v-flex>
                      </v-layout>
                      <!-- Row 5 -->
                      <v-layout row wrap>
                        <v-flex xs6 md6 lg4 v-if="queryModeTtyStmtLn">
                          <v-subheader class="queryLabel">{{ ttyStmtLnlabels.stmtLnType }}</v-subheader>
                          <div class="queryValue">{{ ttyStmtLnForm.stmtLnType }}</div>
                        </v-flex>
                        <v-flex xs6 md6 lg4 v-else>
                          <v-text-field
                            v-model="ttyStmtLnForm.stmtLnType"
                            v-validate="'required'"
                            :label="ttyStmtLnlabels.stmtLnType"
                            data-vv-name="stmtLnType"
                            :data-vv-as="ttyStmtLnlabels.stmtLnType"
                            :error-messages="errors.collect('stmtLnType')"
                            @change="checkStmtLnBusAn()"
                            :disabled="!newModeTtyStmtLn"
                          >
                            <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                              <v-icon color="info" @click="getHelpList('stmtLnType')" v-text="'mdi-magnify'"></v-icon>
                            </v-slide-x-reverse-transition>
                          </v-text-field>
                        </v-flex>
                        <v-flex xs6 md6 lg4 v-if="queryModeTtyStmtLn">
                          <v-subheader class="queryLabel">{{ ttyStmtLnlabels.stmtLnTypeDesc }}</v-subheader>
                          <div class="queryValue">{{ ttyStmtLnForm.stmtLnTypeDesc }}</div>
                        </v-flex>
                        <v-flex xs6 md6 lg4 v-else>
                          <v-text-field
                            v-model="ttyStmtLnForm.stmtLnTypeDesc"
                            v-validate="'required'"
                            :label="ttyStmtLnlabels.stmtLnTypeDesc"
                            item-text="label"
                            item-value="value"
                            data-vv-name="stmtLnTypeDesc"
                            :error-messages="errors.collect('stmtLnTypeDesc')"
                            :data-vv-as="ttyStmtLnlabels.stmtLnTypeDesc"
                            readonly
                            :disabled="!newModeTtyStmtLn"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs6 md6 lg4 v-if="queryModeTtyStmtLn">
                          <v-subheader class="queryLabel">{{ ttyStmtLnlabels.stmtLnSeq }}</v-subheader>
                          <div class="queryValue">{{ ttyStmtLnForm.stmtLnSeq }}</div>
                        </v-flex>
                        <v-flex xs6 md6 lg4 v-else>
                          <v-text-field
                            v-model="ttyStmtLnForm.stmtLnSeq"
                            v-validate="checkStmtLnSeq"
                            :label="ttyStmtLnlabels.stmtLnSeq"
                            item-text="label"
                            item-value="value"
                            data-vv-name="stmtLnSeq"
                            :error-messages="errors.collect('stmtLnSeq')"
                            :data-vv-as="ttyStmtLnlabels.stmtLnSeq"
                            :readonly="!newModeTtyStmtLn"
                            :disabled="!newModeTtyStmtLn"
                            @change="resetStmtLnSeq()"
                          ></v-text-field>
                        </v-flex>
                        <!-- Row 6 -->
                        <v-flex xs6 md6 lg4 v-if="queryModeTtyStmtLn">
                          <v-subheader class="queryLabel">{{ ttyStmtLnlabels.busAn }}</v-subheader>
                          <div class="queryValue">{{ ttyStmtLnForm.busAn }}</div>
                        </v-flex>
                        <v-flex xs6 md6 lg4 v-else>
                          <v-autocomplete
                            :items="busAnList"
                            :label="ttyStmtLnlabels.busAn"
                            v-model="ttyStmtLnForm.busAn"
                            item-text="label"
                            item-value="value"
                            return-object
                            data-vv-name="ttyStmtLnForm.busAn"
                            :error-messages="errors.collect('ttyStmtLnForm.busAn')"
                            :data-vv-as="ttyStmtLnlabels.busAn"
                            :disabled="!newModeTtyStmtLn"
                            @change="doAssignBusCls(ttyStmtLnForm.busAn)"
                          ></v-autocomplete>
                        </v-flex>
                        <v-flex xs6 md6 lg4 v-if="queryModeTtyStmtLn">
                          <v-subheader class="queryLabel">{{ ttyStmtLnlabels.busAnDesc }}</v-subheader>
                          <div class="queryValue">{{ ttyStmtLnForm.busAnDesc }}</div>
                        </v-flex>
                        <v-flex xs6 md6 lg4 v-else>
                          <v-text-field
                            v-model="ttyStmtLnForm.busAnDesc"
                            v-validate="'entry'"
                            :label="ttyStmtLnlabels.busAnDesc"
                            item-text="label"
                            item-value="value"
                            data-vv-name="busAnDesc"
                            :error-messages="errors.collect('busAnDesc')"
                            :data-vv-as="ttyStmtLnlabels.busAnDesc"
                            readonly
                            :disabled="!newModeTtyStmtLn"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                      <!-- Row 7 Header -->
                      <v-layout row wrap>
                        <v-flex xs3></v-flex>
                        <v-flex xs3>
                          <v-subheader class="queryLabel">{{ ttyStmtLnlabels.gross }}</v-subheader>
                          <!-- <div class="queryValue">{{ttyStmtLnForm.busAn}}</div> -->
                        </v-flex>
                        <v-flex xs3>
                          <v-subheader class="queryLabel">{{ ttyStmtLnlabels.net }}</v-subheader>
                          <!-- <div class="queryValue">{{ttyStmtLnForm.busAn}}</div> -->
                        </v-flex>
                        <v-flex xs3>
                          <v-subheader class="queryLabel">{{ ttyStmtLnlabels.absNet }}</v-subheader>
                          <!-- <div class="queryValue">{{ttyStmtLnForm.busAn}}</div> -->
                        </v-flex>
                      </v-layout>
                      <!-- Row 8 - 100% Amount -->
                      <v-layout row wrap>
                        <v-flex xs3>
                          <v-subheader>{{ ttyStmtLnlabels.amt }}</v-subheader>
                        </v-flex>
                        <v-flex xs3 v-if="queryModeTtyStmtLn">
                          <v-subheader class="queryLabel">{{ ttyStmtLnlabels.amtA }}</v-subheader>
                          <div class="queryValue">{{ ttyStmtLnForm.amtA }}</div>
                        </v-flex>
                        <v-flex xs3 v-else>
                          <v-text-field
                            v-model="ttyStmtLnForm.amtA"
                            v-validate="'required'"
                            :label="ttyStmtLnlabels.amtA"
                            v-num-mask="{ negative: true, intScale: 13, decScale: 2 }"
                            item-text="label"
                            item-value="value"
                            data-vv-name="amtA"
                            :error-messages="errors.collect('amtA')"
                            :data-vv-as="ttyStmtLnlabels.amtA"
                            :disabled="!ttyStmtLnForm.aedA"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs3 v-if="queryModeTtyStmtLn">
                          <v-subheader class="queryLabel">{{ ttyStmtLnlabels.amtB }}</v-subheader>
                          <div class="queryValue">{{ ttyStmtLnForm.amtB }}</div>
                        </v-flex>
                        <v-flex xs3 v-else>
                          <v-text-field
                            v-model="ttyStmtLnForm.amtB"
                            v-validate="'required'"
                            :label="ttyStmtLnlabels.amtB"
                            v-num-mask="{ negative: true, intScale: 13, decScale: 2 }"
                            item-text="label"
                            item-value="value"
                            data-vv-name="amtB"
                            :error-messages="errors.collect('amtB')"
                            :data-vv-as="ttyStmtLnlabels.amtB"
                            :disabled="!ttyStmtLnForm.aedB"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs3 v-if="queryModeTtyStmtLn">
                          <v-subheader class="queryLabel">{{ ttyStmtLnlabels.amtC }}</v-subheader>
                          <div class="queryValue">{{ ttyStmtLnForm.amtC }}</div>
                        </v-flex>
                        <v-flex xs3 v-else>
                          <v-text-field
                            v-model="ttyStmtLnForm.amtC"
                            v-validate="'required'"
                            :label="ttyStmtLnlabels.amtC"
                            v-num-mask="{ negative: true, intScale: 13, decScale: 2 }"
                            item-text="label"
                            item-value="value"
                            data-vv-name="amtC"
                            :error-messages="errors.collect('amtC')"
                            :data-vv-as="ttyStmtLnlabels.amtC"
                            :disabled="!ttyStmtLnForm.aedC"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                      <!-- Row 9 - Data Entry A/E -->
                      <v-layout row wrap>
                        <v-flex xs3>
                          <v-subheader>{{ ttyStmtLnlabels.aedA }}</v-subheader>
                        </v-flex>
                        <v-flex xs3 v-if="queryModeTtyStmtLn">
                          <v-checkbox color="primary" v-model="ttyStmtLnForm.aedA" :disabled="true"></v-checkbox>
                        </v-flex>
                        <v-flex xs3 v-else>
                          <v-checkbox color="primary" v-model="ttyStmtLnForm.aedA" @change="calculateAmountA()"></v-checkbox>
                        </v-flex>
                        <v-flex xs3 v-if="queryModeTtyStmtLn">
                          <v-checkbox color="primary" v-model="ttyStmtLnForm.aedB" :disabled="true"></v-checkbox>
                        </v-flex>
                        <v-flex xs3 v-else>
                          <v-checkbox color="primary" v-model="ttyStmtLnForm.aedB" @change="calculateAmountA()"></v-checkbox>
                        </v-flex>
                        <v-flex xs3 v-if="queryModeTtyStmtLn">
                          <v-checkbox color="primary" v-model="ttyStmtLnForm.aedC" :disabled="true"></v-checkbox>
                        </v-flex>
                        <v-flex xs3 v-else>
                          <v-checkbox color="primary" v-model="ttyStmtLnForm.aedC" @change="calculateAmountA()"></v-checkbox>
                        </v-flex>
                      </v-layout>
                      <!-- Row 10 - Amount 1 -->
                      <v-layout row wrap>
                        <v-flex xs3>
                          <v-subheader>{{ this.ttyStmtLnlabels.amt1_6[0] }}</v-subheader>
                        </v-flex>
                        <v-flex xs3 v-if="queryModeTtyStmtLn">
                          <v-layout row wrap>
                            <v-flex xs6>
                              <v-subheader class="queryLabel">{{ ttyStmtLnlabels.amtA }}</v-subheader>
                              <div class="queryValue">{{ ttyStmtLnForm.amt1A }}</div>
                            </v-flex>
                            <v-flex xs6>
                              <v-subheader class="queryLabel">{{ ttyStmtLnlabels.amtA }}</v-subheader>
                              <div class="queryValue">{{ ttyStmtLnForm.amt1ALoc }}</div>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs3 v-else>
                          <v-layout row wrap>
                            <v-flex xs6>
                              <v-text-field
                                v-model="ttyStmtLnForm.amt1A"
                                v-validate="'required'"
                                :label="ttyStmtLnlabels.amt1A"
                                v-num-mask="{ negative: true, intScale: 13, decScale: 2 }"
                                item-text="label"
                                item-value="value"
                                data-vv-name="amt1A"
                                :error-messages="errors.collect('amt1A')"
                                :data-vv-as="ttyStmtLnlabels.amt1A"
                                :disabled="ttyStmtLnForm.aedA"
                                @blur="doCalculateCurrRate()"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs6>
                              <v-text-field
                                v-model="ttyStmtLnForm.amt1ALoc"
                                v-validate="'required'"
                                :label="ttyStmtLnlabels.amt1ALoc"
                                v-num-mask="{ negative: true, intScale: 13, decScale: 2 }"
                                item-text="label"
                                item-value="value"
                                data-vv-name="amt1ALoc"
                                :error-messages="errors.collect('amt1ALoc')"
                                :data-vv-as="ttyStmtLnlabels.amt1ALoc"
                                :disabled="ttyStmtLnForm.aedA"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs3 v-if="queryModeTtyStmtLn">
                          <v-layout row wrap>
                            <v-flex xs6>
                              <v-subheader class="queryLabel">{{ ttyStmtLnlabels.amtB }}</v-subheader>
                              <div class="queryValue">{{ ttyStmtLnForm.amt1B }}</div>
                            </v-flex>
                            <v-flex xs6>
                              <v-subheader class="queryLabel">{{ ttyStmtLnlabels.amtB }}</v-subheader>
                              <div class="queryValue">{{ ttyStmtLnForm.amt1BLoc }}</div>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs3 v-else>
                          <v-layout row wrap>
                            <v-flex xs6>
                              <v-text-field
                                v-model="ttyStmtLnForm.amt1B"
                                v-validate="'required'"
                                :label="ttyStmtLnlabels.amt1B"
                                v-num-mask="{ negative: true, intScale: 13, decScale: 2 }"
                                item-text="label"
                                item-value="value"
                                data-vv-name="amt1B"
                                :error-messages="errors.collect('amt1B')"
                                :data-vv-as="ttyStmtLnlabels.amt1B"
                                :disabled="ttyStmtLnForm.aedB"
                                @blur="doCalculateCurrRate()"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs6>
                              <v-text-field
                                v-model="ttyStmtLnForm.amt1BLoc"
                                v-validate="'required'"
                                :label="ttyStmtLnlabels.amt1BLoc"
                                v-num-mask="{ negative: true, intScale: 13, decScale: 2 }"
                                item-text="label"
                                item-value="value"
                                data-vv-name="amt1BLoc"
                                :error-messages="errors.collect('amt1BLoc')"
                                :data-vv-as="ttyStmtLnlabels.amt1BLoc"
                                :disabled="ttyStmtLnForm.aedB"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs3 v-if="queryModeTtyStmtLn">
                          <v-layout row wrap>
                            <v-flex xs6>
                              <v-subheader class="queryLabel">{{ ttyStmtLnlabels.amtC }}</v-subheader>
                              <div class="queryValue">{{ ttyStmtLnForm.amt1C }}</div>
                            </v-flex>
                            <v-flex xs6>
                              <v-subheader class="queryLabel">{{ ttyStmtLnlabels.amtC }}</v-subheader>
                              <div class="queryValue">{{ ttyStmtLnForm.amt1CLoc }}</div>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs3 v-else>
                          <v-layout row wrap>
                            <v-flex xs6>
                              <v-text-field
                                v-model="ttyStmtLnForm.amt1C"
                                v-validate="'required'"
                                :label="ttyStmtLnlabels.amt1C"
                                v-num-mask="{ negative: true, intScale: 13, decScale: 2 }"
                                item-text="label"
                                item-value="value"
                                data-vv-name="amt1C"
                                :error-messages="errors.collect('amt1C')"
                                :data-vv-as="ttyStmtLnlabels.amt1C"
                                :disabled="ttyStmtLnForm.aedC"
                                @blur="doCalculateCurrRate()"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs6>
                              <v-text-field
                                v-model="ttyStmtLnForm.amt1CLoc"
                                v-validate="'required'"
                                :label="ttyStmtLnlabels.amt1CLoc"
                                v-num-mask="{ negative: true, intScale: 13, decScale: 2 }"
                                item-text="label"
                                item-value="value"
                                data-vv-name="amt1CLoc"
                                :error-messages="errors.collect('amt1CLoc')"
                                :data-vv-as="ttyStmtLnlabels.amt1CLoc"
                                :disabled="ttyStmtLnForm.aedC"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                      <!-- Row 11 - Amount 2 -->
                      <v-layout row wrap>
                        <v-flex xs3>
                          <v-subheader>{{ this.ttyStmtLnlabels.amt1_6[1] }}</v-subheader>
                        </v-flex>
                        <v-flex xs3 v-if="queryModeTtyStmtLn">
                          <v-layout row wrap>
                            <v-flex xs6>
                              <v-subheader class="queryLabel">{{ ttyStmtLnlabels.amtA }}</v-subheader>
                              <div class="queryValue">{{ ttyStmtLnForm.amt2A }}</div>
                            </v-flex>
                            <v-flex xs6>
                              <v-subheader class="queryLabel">{{ ttyStmtLnlabels.amtA }}</v-subheader>
                              <div class="queryValue">{{ ttyStmtLnForm.amt2ALoc }}</div>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs3 v-else>
                          <v-layout row wrap>
                            <v-flex xs6>
                              <v-text-field
                                v-model="ttyStmtLnForm.amt2A"
                                v-validate="'required'"
                                :label="ttyStmtLnlabels.amt2A"
                                v-num-mask="{ negative: true, intScale: 13, decScale: 2 }"
                                item-text="label"
                                item-value="value"
                                data-vv-name="amt2A"
                                :error-messages="errors.collect('amt2A')"
                                :data-vv-as="ttyStmtLnlabels.amt2A"
                                :disabled="ttyStmtLnForm.aedA"
                                @blur="doCalculateCurrRate()"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs6>
                              <v-text-field
                                v-model="ttyStmtLnForm.amt2ALoc"
                                v-validate="'required'"
                                :label="ttyStmtLnlabels.amt2ALoc"
                                v-num-mask="{ negative: true, intScale: 13, decScale: 2 }"
                                item-text="label"
                                item-value="value"
                                data-vv-name="amt2ALoc"
                                :error-messages="errors.collect('amt2ALoc')"
                                :data-vv-as="ttyStmtLnlabels.amt2ALoc"
                                :disabled="ttyStmtLnForm.aedA"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs3 v-if="queryModeTtyStmtLn">
                          <v-layout row wrap>
                            <v-flex xs6>
                              <v-subheader class="queryLabel">{{ ttyStmtLnlabels.amtB }}</v-subheader>
                              <div class="queryValue">{{ ttyStmtLnForm.amt2B }}</div>
                            </v-flex>
                            <v-flex xs6>
                              <v-subheader class="queryLabel">{{ ttyStmtLnlabels.amtB }}</v-subheader>
                              <div class="queryValue">{{ ttyStmtLnForm.amt2BLoc }}</div>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs3 v-else>
                          <v-layout row wrap>
                            <v-flex xs6>
                              <v-text-field
                                v-model="ttyStmtLnForm.amt2B"
                                v-validate="'required'"
                                :label="ttyStmtLnlabels.amt2B"
                                v-num-mask="{ negative: true, intScale: 13, decScale: 2 }"
                                item-text="label"
                                item-value="value"
                                data-vv-name="amt2B"
                                :error-messages="errors.collect('amt2B')"
                                :data-vv-as="ttyStmtLnlabels.amt2B"
                                :disabled="ttyStmtLnForm.aedB"
                                @blur="doCalculateCurrRate()"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs6>
                              <v-text-field
                                v-model="ttyStmtLnForm.amt2BLoc"
                                v-validate="'required'"
                                :label="ttyStmtLnlabels.amt2BLoc"
                                v-num-mask="{ negative: true, intScale: 13, decScale: 2 }"
                                item-text="label"
                                item-value="value"
                                data-vv-name="amt2BLoc"
                                :error-messages="errors.collect('amt2BLoc')"
                                :data-vv-as="ttyStmtLnlabels.amt2BLoc"
                                :disabled="ttyStmtLnForm.aedB"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs3 v-if="queryModeTtyStmtLn">
                          <v-layout row wrap>
                            <v-flex xs6>
                              <v-subheader class="queryLabel">{{ ttyStmtLnlabels.amtC }}</v-subheader>
                              <div class="queryValue">{{ ttyStmtLnForm.amt2C }}</div>
                            </v-flex>
                            <v-flex xs6>
                              <v-subheader class="queryLabel">{{ ttyStmtLnlabels.amtC }}</v-subheader>
                              <div class="queryValue">{{ ttyStmtLnForm.amt2CLoc }}</div>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs3 v-else>
                          <v-layout row wrap>
                            <v-flex xs6>
                              <v-text-field
                                v-model="ttyStmtLnForm.amt2C"
                                v-validate="'required'"
                                :label="ttyStmtLnlabels.amt2C"
                                v-num-mask="{ negative: true, intScale: 13, decScale: 2 }"
                                item-text="label"
                                item-value="value"
                                data-vv-name="amt2C"
                                :error-messages="errors.collect('amt2C')"
                                :data-vv-as="ttyStmtLnlabels.amt2C"
                                :disabled="ttyStmtLnForm.aedC"
                                @blur="doCalculateCurrRate()"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs6>
                              <v-text-field
                                v-model="ttyStmtLnForm.amt2CLoc"
                                v-validate="'required'"
                                :label="ttyStmtLnlabels.amt2CLoc"
                                v-num-mask="{ negative: true, intScale: 13, decScale: 2 }"
                                item-text="label"
                                item-value="value"
                                data-vv-name="amt2CLoc"
                                :error-messages="errors.collect('amt2CLoc')"
                                :data-vv-as="ttyStmtLnlabels.amt2CLoc"
                                :disabled="ttyStmtLnForm.aedC"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                      <!-- Row 12 - Amount 3 -->
                      <v-layout row wrap v-if="this.riskAreaCount === 3">
                        <v-flex xs3>
                          <v-subheader>{{ ttyStmtLnlabels.amt3 }}</v-subheader>
                        </v-flex>
                        <v-flex xs3 v-if="queryModeTtyStmtLn">
                          <v-layout row wrap>
                            <v-flex xs6>
                              <v-subheader class="queryLabel">{{ ttyStmtLnlabels.amtA }}</v-subheader>
                              <div class="queryValue">{{ ttyStmtLnForm.amt3A }}</div>
                            </v-flex>
                            <v-flex xs6>
                              <v-subheader class="queryLabel">{{ ttyStmtLnlabels.amtA }}</v-subheader>
                              <div class="queryValue">{{ ttyStmtLnForm.amt3ALoc }}</div>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs3 v-else>
                          <v-layout row wrap>
                            <v-flex xs6>
                              <v-text-field
                                v-model="ttyStmtLnForm.amt3A"
                                v-validate="'required'"
                                :label="ttyStmtLnlabels.amt3A"
                                v-num-mask="{ negative: true, intScale: 13, decScale: 2 }"
                                item-text="label"
                                item-value="value"
                                data-vv-name="amt3A"
                                :error-messages="errors.collect('amt3A')"
                                :data-vv-as="ttyStmtLnlabels.amt3A"
                                :disabled="ttyStmtLnForm.aedA"
                                @blur="doCalculateCurrRate()"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs6>
                              <v-text-field
                                v-model="ttyStmtLnForm.amt3ALoc"
                                v-validate="'required'"
                                :label="ttyStmtLnlabels.amt3ALoc"
                                v-num-mask="{ negative: true, intScale: 13, decScale: 2 }"
                                item-text="label"
                                item-value="value"
                                data-vv-name="amt3ALoc"
                                :error-messages="errors.collect('amt3ALoc')"
                                :data-vv-as="ttyStmtLnlabels.amt3ALoc"
                                :disabled="ttyStmtLnForm.aedA"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs3 v-if="queryModeTtyStmtLn">
                          <v-layout row wrap>
                            <v-flex xs6>
                              <v-subheader class="queryLabel">{{ ttyStmtLnlabels.amtB }}</v-subheader>
                              <div class="queryValue">{{ ttyStmtLnForm.amt3B }}</div>
                            </v-flex>
                            <v-flex xs6>
                              <v-subheader class="queryLabel">{{ ttyStmtLnlabels.amtB }}</v-subheader>
                              <div class="queryValue">{{ ttyStmtLnForm.amt3BLoc }}</div>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs3 v-else>
                          <v-layout row wrap>
                            <v-flex xs6>
                              <v-text-field
                                v-model="ttyStmtLnForm.amt3B"
                                v-validate="'required'"
                                :label="ttyStmtLnlabels.amt3B"
                                v-num-mask="{ negative: true, intScale: 13, decScale: 2 }"
                                item-text="label"
                                item-value="value"
                                data-vv-name="amt3B"
                                :error-messages="errors.collect('amt3B')"
                                :data-vv-as="ttyStmtLnlabels.amt3B"
                                :disabled="ttyStmtLnForm.aedB"
                                @blur="doCalculateCurrRate()"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs6>
                              <v-text-field
                                v-model="ttyStmtLnForm.amt3BLoc"
                                v-validate="'required'"
                                :label="ttyStmtLnlabels.amt3BLoc"
                                v-num-mask="{ negative: true, intScale: 13, decScale: 2 }"
                                item-text="label"
                                item-value="value"
                                data-vv-name="amt3BLoc"
                                :error-messages="errors.collect('amt3BLoc')"
                                :data-vv-as="ttyStmtLnlabels.amt3BLoc"
                                :disabled="ttyStmtLnForm.aedB"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs3 v-if="queryModeTtyStmtLn">
                          <v-layout row wrap>
                            <v-flex xs6>
                              <v-subheader class="queryLabel">{{ ttyStmtLnlabels.amtC }}</v-subheader>
                              <div class="queryValue">{{ ttyStmtLnForm.amt3C }}</div>
                            </v-flex>
                            <v-flex xs6>
                              <v-subheader class="queryLabel">{{ ttyStmtLnlabels.amtC }}</v-subheader>
                              <div class="queryValue">{{ ttyStmtLnForm.amt3CLoc }}</div>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs3 v-else>
                          <v-layout row wrap>
                            <v-flex xs6>
                              <v-text-field
                                v-model="ttyStmtLnForm.amt3C"
                                v-validate="'required'"
                                :label="ttyStmtLnlabels.amt3C"
                                v-num-mask="{ negative: true, intScale: 13, decScale: 2 }"
                                item-text="label"
                                item-value="value"
                                data-vv-name="amt3C"
                                :error-messages="errors.collect('amt3C')"
                                :data-vv-as="ttyStmtLnlabels.amt3C"
                                :disabled="ttyStmtLnForm.aedC"
                                @blur="doCalculateCurrRate()"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs6>
                              <v-text-field
                                v-model="ttyStmtLnForm.amt3CLoc"
                                v-validate="'required'"
                                :label="ttyStmtLnlabels.amt3CLoc"
                                v-num-mask="{ negative: true, intScale: 13, decScale: 2 }"
                                item-text="label"
                                item-value="value"
                                data-vv-name="amt3CLoc"
                                :error-messages="errors.collect('amt3CLoc')"
                                :data-vv-as="ttyStmtLnlabels.amt3CLoc"
                                :disabled="ttyStmtLnForm.aedC"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                      <!-- Row 13 - Amount 4 -->
                      <v-layout row wrap v-if="this.riskAreaCount === 4">
                        <v-flex xs3>
                          <v-subheader>{{ ttyStmtLnlabels.amt4 }}</v-subheader>
                        </v-flex>
                        <v-flex xs3 v-if="queryModeTtyStmtLn">
                          <v-layout row wrap>
                            <v-flex xs6>
                              <v-subheader class="queryLabel">{{ ttyStmtLnlabels.amtA }}</v-subheader>
                              <div class="queryValue">{{ ttyStmtLnForm.amt4A }}</div>
                            </v-flex>
                            <v-flex xs6>
                              <v-subheader class="queryLabel">{{ ttyStmtLnlabels.amtA }}</v-subheader>
                              <div class="queryValue">{{ ttyStmtLnForm.amt4ALoc }}</div>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs3 v-else>
                          <v-layout row wrap>
                            <v-flex xs6>
                              <v-text-field
                                v-model="ttyStmtLnForm.amt4A"
                                v-validate="'required'"
                                :label="ttyStmtLnlabels.amt4A"
                                v-num-mask="{ negative: true, intScale: 13, decScale: 2 }"
                                item-text="label"
                                item-value="value"
                                data-vv-name="amt4A"
                                :error-messages="errors.collect('amt4A')"
                                :data-vv-as="ttyStmtLnlabels.amt4A"
                                :disabled="ttyStmtLnForm.aedA"
                                @blur="doCalculateCurrRate()"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs6>
                              <v-text-field
                                v-model="ttyStmtLnForm.amt4ALoc"
                                v-validate="'required'"
                                :label="ttyStmtLnlabels.amt4ALoc"
                                v-num-mask="{ negative: true, intScale: 13, decScale: 2 }"
                                item-text="label"
                                item-value="value"
                                data-vv-name="amt4ALoc"
                                :error-messages="errors.collect('amt4ALoc')"
                                :data-vv-as="ttyStmtLnlabels.amt4ALoc"
                                :disabled="ttyStmtLnForm.aedA"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs3 v-if="queryModeTtyStmtLn">
                          <v-layout row wrap>
                            <v-flex xs6>
                              <v-subheader class="queryLabel">{{ ttyStmtLnlabels.amtB }}</v-subheader>
                              <div class="queryValue">{{ ttyStmtLnForm.amt4B }}</div>
                            </v-flex>
                            <v-flex xs6>
                              <v-subheader class="queryLabel">{{ ttyStmtLnlabels.amtB }}</v-subheader>
                              <div class="queryValue">{{ ttyStmtLnForm.amt4BLoc }}</div>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs3 v-else>
                          <v-layout row wrap>
                            <v-flex xs6>
                              <v-text-field
                                v-model="ttyStmtLnForm.amt4B"
                                v-validate="'required'"
                                :label="ttyStmtLnlabels.amt4B"
                                v-num-mask="{ negative: true, intScale: 13, decScale: 2 }"
                                item-text="label"
                                item-value="value"
                                data-vv-name="amt4B"
                                :error-messages="errors.collect('amt4B')"
                                :data-vv-as="ttyStmtLnlabels.amt4B"
                                :disabled="ttyStmtLnForm.aedB"
                                @blur="doCalculateCurrRate()"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs6>
                              <v-text-field
                                v-model="ttyStmtLnForm.amt4BLoc"
                                v-validate="'required'"
                                :label="ttyStmtLnlabels.amt4BLoc"
                                v-num-mask="{ negative: true, intScale: 13, decScale: 2 }"
                                item-text="label"
                                item-value="value"
                                data-vv-name="amt4BLoc"
                                :error-messages="errors.collect('amt4BLoc')"
                                :data-vv-as="ttyStmtLnlabels.amt4BLoc"
                                :disabled="ttyStmtLnForm.aedB"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs3 v-if="queryModeTtyStmtLn">
                          <v-layout row wrap>
                            <v-flex xs6>
                              <v-subheader class="queryLabel">{{ ttyStmtLnlabels.amtC }}</v-subheader>
                              <div class="queryValue">{{ ttyStmtLnForm.amt4C }}</div>
                            </v-flex>
                            <v-flex xs6>
                              <v-subheader class="queryLabel">{{ ttyStmtLnlabels.amtC }}</v-subheader>
                              <div class="queryValue">{{ ttyStmtLnForm.amt4CLoc }}</div>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs3 v-else>
                          <v-layout row wrap>
                            <v-flex xs6>
                              <v-text-field
                                v-model="ttyStmtLnForm.amt4C"
                                v-validate="'required'"
                                :label="ttyStmtLnlabels.amt4C"
                                v-num-mask="{ negative: true, intScale: 13, decScale: 2 }"
                                item-text="label"
                                item-value="value"
                                data-vv-name="amt4C"
                                :error-messages="errors.collect('amt4C')"
                                :data-vv-as="ttyStmtLnlabels.amt4C"
                                :disabled="ttyStmtLnForm.aedC"
                                @blur="doCalculateCurrRate()"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs6>
                              <v-text-field
                                v-model="ttyStmtLnForm.amt4CLoc"
                                v-validate="'required'"
                                :label="ttyStmtLnlabels.amt4CLoc"
                                v-num-mask="{ negative: true, intScale: 13, decScale: 2 }"
                                item-text="label"
                                item-value="value"
                                data-vv-name="amt4CLoc"
                                :error-messages="errors.collect('amt4CLoc')"
                                :data-vv-as="ttyStmtLnlabels.amt4CLoc"
                                :disabled="ttyStmtLnForm.aedC"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                      <!-- Row 13 - Amount 5 -->
                      <v-layout row wrap v-if="this.riskAreaCount === 5">
                        <v-flex xs3>
                          <v-subheader>{{ ttyStmtLnlabels.amt5 }}</v-subheader>
                        </v-flex>
                        <v-flex xs3 v-if="queryModeTtyStmtLn">
                          <v-layout row wrap>
                            <v-flex xs6>
                              <v-subheader class="queryLabel">{{ ttyStmtLnlabels.amtA }}</v-subheader>
                              <div class="queryValue">{{ ttyStmtLnForm.amt5A }}</div>
                            </v-flex>
                            <v-flex xs6>
                              <v-subheader class="queryLabel">{{ ttyStmtLnlabels.amtA }}</v-subheader>
                              <div class="queryValue">{{ ttyStmtLnForm.amt5ALoc }}</div>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs3 v-else>
                          <v-layout row wrap>
                            <v-flex xs6>
                              <v-text-field
                                v-model="ttyStmtLnForm.amt5A"
                                v-validate="'required'"
                                :label="ttyStmtLnlabels.amt5A"
                                v-num-mask="{ negative: true, intScale: 13, decScale: 2 }"
                                item-text="label"
                                item-value="value"
                                data-vv-name="amt5A"
                                :error-messages="errors.collect('amt5A')"
                                :data-vv-as="ttyStmtLnlabels.amt5A"
                                :disabled="ttyStmtLnForm.aedA"
                                @blur="doCalculateCurrRate()"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs6>
                              <v-text-field
                                v-model="ttyStmtLnForm.amt5ALoc"
                                v-validate="'required'"
                                :label="ttyStmtLnlabels.amt5ALoc"
                                v-num-mask="{ negative: true, intScale: 13, decScale: 2 }"
                                item-text="label"
                                item-value="value"
                                data-vv-name="amt5ALoc"
                                :error-messages="errors.collect('amt5ALoc')"
                                :data-vv-as="ttyStmtLnlabels.amt5ALoc"
                                :disabled="ttyStmtLnForm.aedA"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs3 v-if="queryModeTtyStmtLn">
                          <v-layout row wrap>
                            <v-flex xs6>
                              <v-subheader class="queryLabel">{{ ttyStmtLnlabels.amtB }}</v-subheader>
                              <div class="queryValue">{{ ttyStmtLnForm.amt5B }}</div>
                            </v-flex>
                            <v-flex xs6>
                              <v-subheader class="queryLabel">{{ ttyStmtLnlabels.amtB }}</v-subheader>
                              <div class="queryValue">{{ ttyStmtLnForm.amt5BLoc }}</div>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs3 v-else>
                          <v-layout row wrap>
                            <v-flex xs6>
                              <v-text-field
                                v-model="ttyStmtLnForm.amt5B"
                                v-validate="'required'"
                                :label="ttyStmtLnlabels.amt5B"
                                v-num-mask="{ negative: true, intScale: 13, decScale: 2 }"
                                item-text="label"
                                item-value="value"
                                data-vv-name="amt5B"
                                :error-messages="errors.collect('amt5B')"
                                :data-vv-as="ttyStmtLnlabels.amt5B"
                                :disabled="ttyStmtLnForm.aedB"
                                @blur="doCalculateCurrRate()"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs6>
                              <v-text-field
                                v-model="ttyStmtLnForm.amt5BLoc"
                                v-validate="'required'"
                                :label="ttyStmtLnlabels.amt5BLoc"
                                v-num-mask="{ negative: true, intScale: 13, decScale: 2 }"
                                item-text="label"
                                item-value="value"
                                data-vv-name="amt5BLoc"
                                :error-messages="errors.collect('amt5BLoc')"
                                :data-vv-as="ttyStmtLnlabels.amt5BLoc"
                                :disabled="ttyStmtLnForm.aedB"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs3 v-if="queryModeTtyStmtLn">
                          <v-layout row wrap>
                            <v-flex xs6>
                              <v-subheader class="queryLabel">{{ ttyStmtLnlabels.amtC }}</v-subheader>
                              <div class="queryValue">{{ ttyStmtLnForm.amt5C }}</div>
                            </v-flex>
                            <v-flex xs6>
                              <v-subheader class="queryLabel">{{ ttyStmtLnlabels.amtC }}</v-subheader>
                              <div class="queryValue">{{ ttyStmtLnForm.amt5CLoc }}</div>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs3 v-else>
                          <v-layout row wrap>
                            <v-flex xs6>
                              <v-text-field
                                v-model="ttyStmtLnForm.amt5C"
                                v-validate="'required'"
                                :label="ttyStmtLnlabels.amt5C"
                                v-num-mask="{ negative: true, intScale: 13, decScale: 2 }"
                                item-text="label"
                                item-value="value"
                                data-vv-name="amt5C"
                                :error-messages="errors.collect('amt5C')"
                                :data-vv-as="ttyStmtLnlabels.amt5C"
                                :disabled="ttyStmtLnForm.aedC"
                                @blur="doCalculateCurrRate()"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs6>
                              <v-text-field
                                v-model="ttyStmtLnForm.amt5CLoc"
                                v-validate="'required'"
                                :label="ttyStmtLnlabels.amt5CLoc"
                                v-num-mask="{ negative: true, intScale: 13, decScale: 2 }"
                                item-text="label"
                                item-value="value"
                                data-vv-name="amt5CLoc"
                                :error-messages="errors.collect('amt5CLoc')"
                                :data-vv-as="ttyStmtLnlabels.amt5CLoc"
                                :disabled="ttyStmtLnForm.aedC"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                      <!-- Row 13 - Amount 6 -->
                      <v-layout row wrap  v-if="this.riskAreaCount === 6">
                        <v-flex xs3>
                          <v-subheader>{{ ttyStmtLnlabels.amt6 }}</v-subheader>
                        </v-flex>
                        <v-flex xs3 v-if="queryModeTtyStmtLn">
                          <v-layout row wrap>
                            <v-flex xs6>
                              <v-subheader class="queryLabel">{{ ttyStmtLnlabels.amtA }}</v-subheader>
                              <div class="queryValue">{{ ttyStmtLnForm.amt6A }}</div>
                            </v-flex>
                            <v-flex xs6>
                              <v-subheader class="queryLabel">{{ ttyStmtLnlabels.amtA }}</v-subheader>
                              <div class="queryValue">{{ ttyStmtLnForm.amt6ALoc }}</div>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs3 v-else>
                          <v-layout row wrap>
                            <v-flex xs6>
                              <v-text-field
                                v-model="ttyStmtLnForm.amt6A"
                                v-validate="'required'"
                                :label="ttyStmtLnlabels.amt6A"
                                v-num-mask="{ negative: true, intScale: 13, decScale: 2 }"
                                item-text="label"
                                item-value="value"
                                data-vv-name="amt6A"
                                :error-messages="errors.collect('amt6A')"
                                :data-vv-as="ttyStmtLnlabels.amt6A"
                                :disabled="ttyStmtLnForm.aedA"
                                @blur="doCalculateCurrRate()"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs6>
                              <v-text-field
                                v-model="ttyStmtLnForm.amt6ALoc"
                                v-validate="'required'"
                                :label="ttyStmtLnlabels.amt6ALoc"
                                v-num-mask="{ negative: true, intScale: 13, decScale: 2 }"
                                item-text="label"
                                item-value="value"
                                data-vv-name="amt6ALoc"
                                :error-messages="errors.collect('amt6ALoc')"
                                :data-vv-as="ttyStmtLnlabels.amt6ALoc"
                                :disabled="ttyStmtLnForm.aedA"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs3 v-if="queryModeTtyStmtLn">
                          <v-layout row wrap>
                            <v-flex xs6>
                              <v-subheader class="queryLabel">{{ ttyStmtLnlabels.amtB }}</v-subheader>
                              <div class="queryValue">{{ ttyStmtLnForm.amt6B }}</div>
                            </v-flex>
                            <v-flex xs6>
                              <v-subheader class="queryLabel">{{ ttyStmtLnlabels.amtB }}</v-subheader>
                              <div class="queryValue">{{ ttyStmtLnForm.amt6BLoc }}</div>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs3 v-else>
                          <v-layout row wrap>
                            <v-flex xs6>
                              <v-text-field
                                v-model="ttyStmtLnForm.amt6B"
                                v-validate="'required'"
                                :label="ttyStmtLnlabels.amt6B"
                                v-num-mask="{ negative: true, intScale: 13, decScale: 2 }"
                                item-text="label"
                                item-value="value"
                                data-vv-name="amt6B"
                                :error-messages="errors.collect('amt6B')"
                                :data-vv-as="ttyStmtLnlabels.amt6B"
                                :disabled="ttyStmtLnForm.aedB"
                                @blur="doCalculateCurrRate()"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs6>
                              <v-text-field
                                v-model="ttyStmtLnForm.amt6BLoc"
                                v-validate="'required'"
                                :label="ttyStmtLnlabels.amt6BLoc"
                                v-num-mask="{ negative: true, intScale: 13, decScale: 2 }"
                                item-text="label"
                                item-value="value"
                                data-vv-name="amt6BLoc"
                                :error-messages="errors.collect('amt6BLoc')"
                                :data-vv-as="ttyStmtLnlabels.amt6BLoc"
                                :disabled="ttyStmtLnForm.aedB"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs3 v-if="queryModeTtyStmtLn">
                          <v-layout row wrap>
                            <v-flex xs6>
                              <v-subheader class="queryLabel">{{ ttyStmtLnlabels.amtC }}</v-subheader>
                              <div class="queryValue">{{ ttyStmtLnForm.amt6C }}</div>
                            </v-flex>
                            <v-flex xs6>
                              <v-subheader class="queryLabel">{{ ttyStmtLnlabels.amtC }}</v-subheader>
                              <div class="queryValue">{{ ttyStmtLnForm.amt6CLoc }}</div>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs3 v-else>
                          <v-layout row wrap>
                            <v-flex xs6>
                              <v-text-field
                                v-model="ttyStmtLnForm.amt6C"
                                v-validate="'required'"
                                :label="ttyStmtLnlabels.amt6C"
                                v-num-mask="{ negative: true, intScale: 13, decScale: 2 }"
                                item-text="label"
                                item-value="value"
                                data-vv-name="amt6C"
                                :error-messages="errors.collect('amt6C')"
                                :data-vv-as="ttyStmtLnlabels.amt6C"
                                :disabled="ttyStmtLnForm.aedC"
                                @blur="doCalculateCurrRate()"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs6>
                              <v-text-field
                                v-model="ttyStmtLnForm.amt6CLoc"
                                v-validate="'required'"
                                :label="ttyStmtLnlabels.amt6CLoc"
                                v-num-mask="{ negative: true, intScale: 13, decScale: 2 }"
                                item-text="label"
                                item-value="value"
                                data-vv-name="amt6CLoc"
                                :error-messages="errors.collect('amt6CLoc')"
                                :data-vv-as="ttyStmtLnlabels.amt6CLoc"
                                :disabled="ttyStmtLnForm.aedC"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                  <v-flex xs12>
                    <v-card-actions>
                      <v-btn color="error" dark class="mb-2" @click.prevent="doCancel">Cancel<v-icon dark right>mdi-cancel</v-icon></v-btn>
                      <!-- <v-btn v-if="(newModeTtyStmtLn && this.ttyStmtLnForm.retroRiRef === '') || reviewModeTtyStmtLn" color="primary" dark class="mb-2" @click="doSaveTtyStmtLn" :loading="submitting">
                        Save
                        <v-icon right>mdi-content-save </v-icon>
                      </v-btn> -->
                      <v-btn
                        v-if="newModeTtyStmtLn || reviewModeTtyStmtLn"
                        color="primary"
                        dark
                        class="mb-2"
                        @click="doSaveTtyStmtLn"
                        :loading="submitting"
                      >
                        Save
                        <v-icon right>mdi-content-save </v-icon>
                      </v-btn>
                      <v-spacer></v-spacer>
                      <v-btn v-if="newMode || reviewModeTtyStmtLn" color="primary" dark @click.prevent="doRelease">
                        {{ ttyStmtLnlabels.release }}
                        <v-icon dark right>mdi-arrow-right-bold-box</v-icon>
                      </v-btn>
                    </v-card-actions>
                  </v-flex>
                </v-card>
                <!-- <treaty-stmt-line :ttyHeaderForm="this.ttyHeaderForm" @assign-ttyRef="assignTtyRef" :ttyStmtLnList1="this.ttyStmtLnList"></treaty-stmt-line> -->
              </v-tab-item>
            </v-tabs-items>
          </v-card-text>
        </v-card>
      </v-flex>
      <prompt-leave
        v-if="showPromptLeave"
        title="Treaty Statement Line"
        v-model="promptLeave"
        @exit="doExit"
        @saveAndExit="doSaveAndExit"
      ></prompt-leave>
    </v-layout>
    <!--Start Delete Prompt -->
    <confirm v-model="promptRemove" @ok="doDeleteTtyStmtLn">
      <p>{{ ttyStmtLnlabels.promptRemoveTtyStmtLn }}</p>
      <div class="queryValue">{{ deleteTtyStmtLn }}</div>
    </confirm>
    <!-- End Delete Prompt-->
    <v-dialog v-model="showCedBrkCoHelpList" width="1280px">
      <cedBrkCo-help-list
        @close="showCedBrkCoHelpList = false"
        :cedFields="this.fieldName"
        :boolRefresh="showCedBrkCoHelpList"
        @assign-cedBrk="assignCedBrkCo"
      ></cedBrkCo-help-list>
    </v-dialog>
    <v-dialog v-model="showTtyRefHelpList" width="1280px">
      <treatyDet-help-list
        @close="showTtyRefHelpList = false"
        :ttyHeaderForm="this.ttyHeaderForm"
        :boolRefresh="showTtyRefHelpList"
        @assign-ttyRef="assignTtyRef"
      ></treatyDet-help-list>
    </v-dialog>
    <v-dialog v-model="showCurrencyHelpList" width="1280px">
      <currency-help-list
        @close="showCurrencyHelpList = false"
        :ttyHeaderForm="this.ttyHeaderForm"
        :boolRefresh="showCurrencyHelpList"
        @assign-currency-info="assignCurrencyInfo"
      ></currency-help-list>
    </v-dialog>
    <v-dialog v-model="showStmtLnTypeHelpList" width="1280px">
      <stmtLnType-help-list
        @close="showStmtLnTypeHelpList = false"
        :ttyHeaderForm="this.ttyHeaderForm"
        :ttyStmtLnForm="parseInt(this.ttyStmtLnForm.retroRiRefUwYr)"
        :boolRefresh="showStmtLnTypeHelpList"
        @assign-stmtLineType="assignStmtLineType"
      ></stmtLnType-help-list>
    </v-dialog>
    <v-dialog v-model="loadingFlag" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Loading...
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showRetroRiUwYrNew" width="800px">
      <form>
        <v-card>
          <v-toolbar dense color="grey lighten-3" flat>
            <v-icon>mdi-clock</v-icon>
            <v-toolbar-title>New Treaty Statement Line Year</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <message :messages="messages"></message>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex md6 xs12>
                  <v-text-field
                    v-model="ttyHeaderForm.retroRiRefNewUwYr"
                    :label="labels.retroRiRefNewUwYr"
                    :error-messages="errors.collect('ttyHeaderForm.retroRiRefNewUwYr')"
                    data-vv-name="ttyHeaderForm.retroRiRefNewUwYr"
                    :data-vv-as="ttyHeaderForm.retroRiRefNewUwYr"
                    v-validate="'entry'"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" text @click.native="closeRetroRiUwYrNew()">Cancel</v-btn>
            <v-btn color="primary" @click="createTtyStmtLnUwYr()">Create New</v-btn>
          </v-card-actions>
        </v-card>
      </form>
    </v-dialog>
  </page>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { filterQuery, expandURI } from '@/utils/ajax'
import { isAfter, isBefore } from 'date-fns'
import { debtSuspTrans, allRI, instalNo } from '@/const/ttyAcct'
import { treatyAjaxMixin } from '@/mixins/treaty/treatyAjaxMixin'
import { treatyListMixin } from '@/mixins/treaty/treatyListMixin'
import PromptLeave from '@/components/core/common/prompt/PromptLeave'
import { formatPrice } from '@/utils/index'
import { formatDisplayNumber, removeFormatNumber } from '@/utils/number'
// import { formatDisplayDate, formatDisplayDateTime2, removeTime, formatDisplayTime } from '@/utils/date'
import { formatDisplayDate, formatDisplayDateTime2, removeTime } from '@/utils/date'
import CedBrkCoHelpList from '@/components/core/common/dialog/CedBrkCoHelpList'
// import CurrencyHelpList from '@/components/core/common/dialog/CurrencyHelpList'
import CurrencyHelpList from '@/components/treaty/helplist/CurrHelpList'
import TreatyDetHelpList from '@/components/treaty/helplist/TreatyDetHelpList'
import StmtLnTypeHelpList from '@/components/treaty/helplist/StmtLnTypeHelpList'
// import TreatyStmtLine from '@/components/treaty/TreatyStmtLine'
import { formatYesNo } from '../../utils/boolean'

export default {
  data() {
    return {
      submitting: false,
      key: 0,
      firstView: true,
      reviewMode: false,
      newMode: true,
      queryMode: false,
      proceed: false,
      loadingFlag: false,
      modeStatus: undefined,
      checkSave: false,
      fieldName: undefined,
      ttyStmtLnList1: [],
      // Helplist
      showCedBrkCoHelpList: false,
      showTtyRefHelpList: false,
      showCurrencyHelpList: false,
      showStmtLnTypeHelpList: false,

      // New RetroRiUwYr
      showRetroRiUwYrNew: false,

      // CedBrkHelplist check
      clickAssignCedBrk: false,
      checkAssignCedBrk: false,

      // CedCoHelplist check
      clickAssignCedCo: false,
      checkAssignCedCo: false,

      // TtyRefHelplist check
      clickAssignTtyRef: false,
      checkAssignTtyRef: false,
      cedBrkFound: false,
      cedCoFound: false,
      ttyRefFound: false,
      ttyStmtTabs: ['Treaty Header', 'Treaty Lines'],
      ttyRefList: [],
      stmtTypeList: [],
      // debtTypeList: [],
      // allRIList: [],
      acctPeriodFound: false,
      tranDateFound: false,
      tranDateRange: false,
      acctPerEndDateFound: false,
      tranDateFrm: undefined,
      tranDateTo: undefined,
      tranDateType: undefined,
      stmtTypeDateType: undefined,
      ttyDetExpDate: undefined,
      labels: {
        cedBrk: 'Ceding Broker',
        cedCo: 'Ceding Company',
        ttyRef: 'Treaty Reference',
        ttyDesc: 'Treaty Description',
        stmtType: 'Statement Type',
        uwYr: 'Underwriting Year',
        tranDate: 'Transaction Date',
        tranRef: 'Transaction Reference',
        acctPer: 'Accounting Period',
        acctYr: 'Accounting Year',
        acctMth: 'Accounting Month',
        debtType: 'Debtor / Suspense Transaction',
        allRI: 'Generate Lines for All Reinsurers?',
        allRet: 'Generate Lines for All Retrocessionaires?',
        stmtPrt: 'Statement Printed',
        acctPerStDate: 'Accounting Period Start Date',
        acctPerEndDate: 'Accounting Period End Date',
        curr: 'Currency',
        currRate: 'Exchange Rate',
        instalNo: 'No. of Instalments',
        release: 'Release',
        ttyYr: 'Treaty Year',
        stmtRef: 'Statement Reference'
      },
      ttyHeaderForm: {
        riType: 'O',
        cedBrk: undefined,
        cedBrkDesc: undefined,
        cedCo: undefined,
        cedCoDesc: undefined,
        ttyRef: undefined,
        ttyDesc: undefined,
        stmtType: undefined,
        uwYr: undefined,
        tranDate: removeTime(new Date()),
        tranDateDisp: undefined,
        tranRef: undefined,
        tranRel: undefined,
        acctPer: undefined,
        acctYr: undefined,
        acctMth: undefined,
        debtType: 'S',
        allRI: 'true',
        stmtPrt: false,
        acctPerStDate: undefined,
        acctPerEndDate: undefined,
        curr: 'SGD',
        currRateAE: true,
        currRate: 1,
        createdProgID: undefined,
        modifiedProgID: undefined,
        instalNo: '1',
        userBranch: undefined,
        ttyYr: undefined,
        stmtRef: undefined,
        retroRiRefNewUwYr: undefined
      },
      miscTreatyFound: false,
      miscTreatyParam: {
        perSuspTran: false,
        perDebtTran: false,
        nxtInwTranRef: undefined,
        nxtOutwTranRef: undefined
      },
      // TtyStmtLn
      newModeTtyStmtLn: false,
      reviewModeTtyStmtLn: false,
      queryModeTtyStmtLn: false,
      showTtyStmtLn: false,
      checkTtyStmtLnList: false,
      ttyStmtLnReview: false,
      showPromptLeave: false,
      promptRemove: false,
      selectedTtyStmtLn: undefined,
      deleteTtyStmtLn: undefined,
      stmtLnSeqExist: false,
      stmtTypeCheck1: false,
      ttyStmtLnTop1Found: false,
      riskAreaCount: 0,
      busAnList: [],
      assignedBusAn: { value: null, secondaryValue: null, label: '' },
      ttyStmtLnlabels: {
        retroRiRef: '',
        riRef: 'Outwards Company',
        acctNoSfx: 'Acct No. Sfx',
        brkRef: 'Outwards Broker',
        brkAcctNoSfx: 'Broker Acct No. Sfx',
        uwYr: 'Underwriting Year',
        cedCoCedBrk: 'Reinsurer / Broker Domicile',
        sharePctOffShares: 'Our Share Offered / Signed',
        stmtLnType: 'Statement Line',
        stmtLnTypeDesc: 'Statement Line Description',
        stmtLnSeq: 'Line Sequence No.',
        busAn: 'BAC',
        busAnDesc: 'BAC Description',
        gross: '(A) Gross',
        net: '(B) Net',
        absNet: '(C) Absolute Net',
        amt: '100% Amount',
        aedA: 'Data Entry A/E',
        amt1: 'Amount 1',
        amt2: 'Amount 2',
        amt3: 'Amount 3',
        amt4: 'Amount 4',
        amt5: 'Amount 5',
        amt6: 'Amount 6',
        amt1_6: [],
        release: 'Retention/Release',
        promptRemoveTtyStmtLn: 'Are you sure you want to delete the selected Treaty Statement Line'
      },
      ttyStmtLnFilter: {
        riType: undefined,
        ttyRef: undefined,
        stmtLnSeq: 0
      },
      ttyStmtLnForm: {
        retroRiRef: '',
        retroRiRefUwYr: '',
        retroRiRefNewUwYr: '',
        riType: undefined,
        ttyRef: undefined,
        riRef: undefined,
        stmtType: undefined,
        acctYr: undefined,
        acctMth: undefined,
        tranRef: undefined,
        acctPerEndDate: undefined,
        acctNoSfx: undefined,
        brkRef: undefined,
        brkAcctNoSfx: undefined,
        uwYr: undefined,
        cedCo: undefined,
        cedBrk: undefined,
        sharePctOff: undefined,
        shares: undefined,
        stmtLnType: undefined,
        stmtLnTypeDesc: undefined,
        stmtLnSeq: undefined,
        busAn: undefined,
        busAnDesc: undefined,
        createdProgID: undefined,
        amtA: 0,
        aedA: false,
        amt1A: 0,
        amt2A: 0,
        amt3A: 0,
        amt4A: 0,
        amt5A: 0,
        amt6A: 0,
        amt1ALoc: 0,
        amt2ALoc: 0,
        amt3ALoc: 0,
        amt4ALoc: 0,
        amt5ALoc: 0,
        amt6ALoc: 0,
        amtB: 0,
        aedB: false,
        amt1B: 0,
        amt2B: 0,
        amt3B: 0,
        amt4B: 0,
        amt5B: 0,
        amt6B: 0,
        amt1BLoc: 0,
        amt2BLoc: 0,
        amt3BLoc: 0,
        amt4BLoc: 0,
        amt5BLoc: 0,
        amt6BLoc: 0,
        amtC: 0,
        aedC: false,
        amt1C: 0,
        amt2C: 0,
        amt3C: 0,
        amt4C: 0,
        amt5C: 0,
        amt6C: 0,
        amt1CLoc: 0,
        amt2CLoc: 0,
        amt3CLoc: 0,
        amt4CLoc: 0,
        amt5CLoc: 0,
        amt6CLoc: 0
      }
    }
  },
  watch: {
    key: function (value) {
      if (value === 1) {
        // console.log('Value key 1')
        if (this.firstView === false) {
          this.getTtyStmtLnList(this.ttyHeaderForm)
        } else {
          this.firstView = false
        }
        // console.log(this.ttyHeaderForm)
        // this.getRetroRIList(this.selectedTty)
        // console.log(this.stmtTypeCheck1)
        if (this.stmtTypeCheck1) {
          // const convertList = {
          //   text: '100%',
          //   value: ''
          // }
          // this.retroRIList.push(convertList)
        }
        if (this.retroRIList.length === 1 || (this.retroRIList.length === 0 && !this.stmtTypeCheck1)) {
          // this.retroRIList = []
          if (this.newMode) {
            const convertList = {
              text: '100%',
              value: ''
            }
            this.retroRIList.unshift(convertList).then((result) => {
              if (result) {
                this.getRetroRIList(this.ttyHeaderForm)
                this.getRetroRIUwYrList(this.ttyHeaderForm)
              }
            })
          } else {
            // const convertList = {
            //   text: '100%',
            //   value: ''
            // }
            // this.selectedTty.uwYr = 2022
            this.getRetroRIList(this.selectedTty)
            this.getRetroRIUwYrList(this.selectedTty)
            // this.retroRIList.unshift(convertList).then((result) => {
            //   if (result) {
            //     console.log('review mode retroList')
            //   }
            // })
          }
        }
      }
    }
  },
  created() {
    this.doInit()
    this.doColumn('ttyStmtLn')
    // if (this.selectedTty === null) {
    //   this.$router.push({ name: 'mngTreatyList' })
    // }
    this.$validator.extend('cedBrkValidation', {
      getMessage(field, args) {
        return `${field} must be a Broker.`
      },
      validate(value, args) {
        if (value) {
          var cedBrkFound = args[0]
          var checkAssignCedBrk = args[1]
          var clickAssignCedBrk = args[2]
          if (cedBrkFound === 'false' && checkAssignCedBrk === 'false' && clickAssignCedBrk === 'false') {
            // console.log('validation false')
            return false
          } else if (cedBrkFound === 'false' && checkAssignCedBrk === 'true' && clickAssignCedBrk === 'false') {
            // console.log('validation false 2')
            return false
          } else {
            // console.log('validation true')
            return true
          }
        }
      }
    })

    this.$validator.extend('cedCoValidation', {
      getMessage(field, args) {
        return `${field} must be a Insurer.`
      },
      validate(value, args) {
        if (value) {
          var cedCoFound = args[0]
          var checkAssignCedCo = args[1]
          var clickAssignCedCo = args[2]
          if (cedCoFound === 'false' && checkAssignCedCo === 'false' && clickAssignCedCo === 'false') {
            // console.log('CedCo validation false')
            return false
          } else if (cedCoFound === 'false' && checkAssignCedCo === 'true' && clickAssignCedCo === 'false') {
            // console.log('CedCo validation false 2')
            return false
          } else {
            // console.log('CedCo validation true')
            return true
          }
        }
      }
    })

    this.$validator.extend('ttyRefValidation', {
      getMessage(field, args) {
        return `${field} Not found on Treaty Detail Parameters (xTreatyDet).`
      },
      validate(value, args) {
        if (value) {
          var ttyRefFound = args[0]
          var checkAssignTtyRef = args[1]
          var clickAssignTtyRef = args[2]
          if (ttyRefFound === 'false' && checkAssignTtyRef === 'false' && clickAssignTtyRef === 'false') {
            return false
          } else if (ttyRefFound === 'false' && checkAssignTtyRef === 'true' && clickAssignTtyRef === 'false') {
            return false
          } else {
            return true
          }
        }
      }
    })

    this.$validator.extend('tranDateRangeValidation', {
      getMessage(field, args) {
        var tranDateFrm = args[0]
        // var tranDateTo = args[1]
        var acctPeriodFound = args[2]
        if (acctPeriodFound === 'false') {
          return `Not set up in GL Accounting Period (xAcctPeriod)`
        } else if (tranDateFrm === 'undefined') {
          return `Not set up in Transaction Date Range(xTranDateRange)`
        } else {
          return `Not permitted in Transaction Date Range (xTranDateRange)`
        }
      },
      validate(value, args) {
        if (value) {
          var tranDateFrm = args[0]
          var tranDateTo = args[1]
          var acctPeriodFound = args[2]
          if (tranDateFrm === 'undefined' || acctPeriodFound === 'false') {
            // console.log('TranDateRange AcctPeriod validation false')
            return false
          } else if (isAfter(removeTime(tranDateFrm), removeTime(value)) || isBefore(removeTime(tranDateTo), removeTime(value))) {
            // console.log('TranDateRange validation false')
            return false
          } else {
            // console.log('TranDateRange validation true')
            return true
          }
        }
      }
    })

    this.$validator.extend('debtTypeValidation', {
      getMessage(field, args) {
        var debtType = args[0]
        var perDebtTran = args[1]
        var perSuspTran = args[2]
        if (perDebtTran === 'false' && debtType === 'D') {
          return `Permit Debtor Transaction Entry is No on Miscellaneous Treaty Parameter (xMiscTreaty).`
        } else if (perSuspTran === 'false' && debtType === 'S') {
          return `Permit Suspense Transaction Entry is No on Miscellaneous Treaty Paratemer (xMiscTreaty).`
        }
      },
      validate(value, args) {
        if (value) {
          var debtType = args[0]
          var perDebtTran = args[1]
          var perSuspTran = args[2]
          // console.log(args)
          if (perDebtTran === 'false' && debtType === 'D') {
            return false
          } else if (perSuspTran === 'false' && debtType === 'S') {
            return false
          } else {
            return true
          }
        }
      }
    })

    this.$validator.extend('acctPerEndDateValidation', {
      getMessage(field, args) {
        var acctPerEndDateFound = args[0]
        var ttyDetExpDate = args[1]
        if (acctPerEndDateFound === 'false') {
          return `No record found with expiry date greater than or equal to your entered value. The highest value of expiry date in xTreatyDet is ${ttyDetExpDate}.`
        } else {
          return `No record found`
        }
      },
      validate(value, args) {
        if (value) {
          var acctPerEndDateFound = args[0]
          // var ttyDetExpDate = args[1]
          // console.log(acctPerEndDateFound)
          if (acctPerEndDateFound === 'false') {
            return false
          } else {
            return true
          }
        }
      }
    })

    this.$validator.extend('stmtLnSeqValidation', {
      getMessage(field, args) {
        return `${field} already exist.`
      },
      validate(value, args) {
        if (value) {
          var stmtLnSeqExist = args[0]
          if (stmtLnSeqExist === 'true') {
            return false
          } else {
            return true
          }
        }
      }
    })
  },
  methods: {
    async doInit() {
      // console.log(formatDisplayDateTime2(this.selectedTty.tranDate))
      await Promise.all([this.$store.dispatch('treatyMasterInit')])
      await Promise.all([this.$store.dispatch('commonsInit')])
      this.modeStatus = this.mode
      this.checkTtyStmtLnList = false
      if (this.modeStatus === 'review') {
        this.newMode = false
        this.reviewMode = true
        this.queryMode = false
        this.doFetchData().then((result) => {
          if (result) {
            // if (this.retroRIList.length === 1) {
            //   this.getRetroRIList(this.ttyHeaderForm)
            // }
            // console.log(this.retroRIList)
            // this.checkTop1TtyStmtLn()
            this.ttyHeaderForm.userBranch = this.userBranch
            if (this.ttyHeaderForm.ttyRef !== '' && this.ttyHeaderForm.ttyRef !== undefined) {
              // console.log('Get TtyStmtLnList 1')
              this.getTtyStmtLnList(this.ttyHeaderForm)
                .then((result1) => {
                  if (result1) {
                    // this.retroRIList = []
                    if (this.stmtTypeCheck1) {
                      const convertList = {
                        text: '100%',
                        value: ''
                      }
                      this.retroRIList.unshift(convertList)
                    }
                    this.getBusAnList(this.ttyHeaderForm)
                  }
                })
                .then((result2) => {
                  if (result2) {
                    if (this.retroRIList.length === 1 || (this.retroRIList.length === 0 && !this.stmtTypeCheck1)) {
                      this.getRetroRIList(this.ttyHeaderForm)
                    }
                  }
                })
              if (this.ttyStmtLnForm.riRef !== undefined && this.ttyStmtLnForm.brkRef !== undefined) {
                this.getCedCoCedBrk(this.ttyHeaderForm, this.ttyStmtLnForm)
              }
            }
          }
        })
      } else if (this.modeStatus === 'query') {
        this.newMode = false
        this.reviewMode = false
        this.queryMode = true
        this.doFetchData()
      } else {
        this.newMode = true
        this.reviewMode = false
        this.queryMode = false
        this.checkTranDate()
      }
      this.getMiscTreatyParam()
      this.getRiskAreaList()
    },
    // async getRetroRIList(ttyHeader) {
    //   console.log(ttyHeader)
    //   const apiUrl = this.menu.getRetroRIList
    //   if (apiUrl) {
    //     try {
    //       const expand = {
    //         riType: ttyHeader.riType,
    //         ttyRef: ttyHeader.ttyRef,
    //         uwYr: ttyHeader.uwYr
    //       }
    //       const result = await this.$http.get(expandURI(apiUrl, expand))
    //       // const { data } = result.data
    //       // console.log(result.data)
    //       if (result.data.dataList) {
    //         result.data.dataList.map(retroRI => {
    //           const convertList = {
    //             text: retroRI.label,
    //             value: retroRI.value
    //           }
    //           this.retroRIList.push(convertList)
    //         })
    //         // this.retroRIList.push(result.data.dataList)
    //         // this.$push(this, 'retroRIList', result.data.dataList)
    //         console.log(this.retroRIList)
    //       }
    //     } catch (err) {
    //       this.loading = false
    //       const { data } = err.response
    //       if (data) {
    //         this.message(data)
    //         this.fieldMessage(data)
    //       }
    //     }
    //   }
    // },
    async doFetchData() {
      const apiUrl = this.menu.getTtyMaster
      if (apiUrl) {
        try {
          const expand = {
            riType: this.selectedTty.riType,
            ttyRef: this.selectedTty.ttyRef,
            stmtType: this.selectedTty.stmtType,
            tranDate: formatDisplayDateTime2(this.selectedTty.tranDate),
            tranRel: this.selectedTty.tranRel,
            tranRef: this.selectedTty.tranRef
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          const { data } = result.data
          if (data) {
            this.ttyHeaderForm.riType = data.ttyMaster.riType
            this.ttyHeaderForm.ttyRef = data.ttyMaster.ttyRef
            this.ttyHeaderForm.ttyDesc = data.ttyMaster.ttyDesc
            this.ttyHeaderForm.stmtType = data.ttyMaster.stmtType
            this.ttyHeaderForm.uwYr = data.ttyMaster.uwYr
            this.ttyHeaderForm.tranDate = data.ttyMaster.tranDate
            this.ttyHeaderForm.tranDateDisp = formatDisplayDateTime2(data.ttyMaster.tranDate)
            this.ttyHeaderForm.tranRel = data.ttyMaster.tranRel
            this.ttyHeaderForm.stmtRef = data.ttyMaster.stmtRef
            this.ttyHeaderForm.tranRef = data.ttyMaster.tranRef
            this.ttyHeaderForm.acctMth = data.ttyMaster.acctMth
            this.ttyHeaderForm.acctYr = data.ttyMaster.acctYr
            this.ttyHeaderForm.debtType = data.ttyMaster.debtType
            if (data.ttyMaster.allRI === true) {
              this.ttyHeaderForm.allRI = 'true'
            } else {
              this.ttyHeaderForm.allRI = 'false'
            }
            // this.ttyHeaderForm.allRI = data.ttyMaster.allRI
            this.ttyHeaderForm.stmtPrt = data.ttyMaster.stmtPrt
            this.ttyHeaderForm.acctPerStDate = data.ttyMaster.acctPerStDate
            this.ttyHeaderForm.acctPerEndDate = data.ttyMaster.acctPerEndDate
            this.ttyHeaderForm.curr = data.ttyMaster.curr
            this.ttyHeaderForm.currRateAE = data.ttyMaster.currRateAE
            this.ttyHeaderForm.currRate = data.ttyMaster.currRate
            this.ttyHeaderForm.instalNo = data.ttyMaster.instalNo.toString()
            this.ttyHeaderForm.createdProgID = data.ttyMaster.createdProgID
            this.ttyHeaderForm.modifiedProgID = data.ttyMaster.modifiedProgID
            if (this.newMode) {
              this.getTtyRef()
            }
            this.getTtyRef()
            this.ttyStmtLnForm.retroRiRefUwYr = data.ttyMaster.uwYr
            this.checkTranDate()
            this.checkAcctPerEndDate()

            return true
          } else {
            return false
          }
        } catch (err) {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    getHelpList(fieldName) {
      this.checkAssignCedBrk = false
      this.fieldName = fieldName
      // console.log('getHelpList fieldName = ' + this.fieldName)
      if (fieldName === 'cedBrk') {
        this.showCedBrkCoHelpList = true
      } else if (fieldName === 'cedCo') {
        this.showCedBrkCoHelpList = true
      } else if (fieldName === 'ttyRef') {
        this.showTtyRefHelpList = true
      } else if (fieldName === 'stmtLnType') {
        this.showStmtLnTypeHelpList = true
      }
    },
    checkCedBrk(fieldName) {
      this.fieldName = fieldName
      if (fieldName === 'cedBrk') {
        this.checkAssignCedBrk = false
        if (this.clickAssignCedBrk) {
          this.checkAssignCedBrk = true
        } else {
          this.checkAssignCedBrk = false
          this.getCedRI()
        }
        this.clickAssignCedBrk = false
      } else if (fieldName === 'cedCo') {
        this.checkAssignCedCo = false
        if (this.clickAssignCedCo) {
          this.checkAssignCedCo = true
        } else {
          this.checkAssignCedCo = false
          this.getCedRI()
        }
        this.clickAssignCedCo = false
      }
    },
    // Check if CedBrk found in CedRI table with CedantType = B || CedCo found in CedRI table with CedantType = I
    async getCedRI() {
      const apiUrl = this.menu.getTop1CedRI
      if (apiUrl) {
        try {
          if (this.fieldName === 'cedBrk') {
            const expand = {
              riRef: this.ttyHeaderForm.cedBrk,
              fieldName: this.fieldName
            }
            const result = await this.$http.get(expandURI(apiUrl, expand))
            const { data } = result.data
            if (data) {
              if (data.cedRI !== null) {
                this.cedBrkFound = true
              } else {
                this.cedBrkFound = false
              }
            } else {
              this.cedBrkFound = false
            }
          } else if (this.fieldName === 'cedCo') {
            const expand = {
              riRef: this.ttyHeaderForm.cedCo,
              fieldName: this.fieldName
            }
            const result = await this.$http.get(expandURI(apiUrl, expand))
            const { data } = result.data
            if (data) {
              if (data.cedRI !== null) {
                this.cedCoFound = true
              } else {
                this.cedCoFound = false
              }
            } else {
              this.cedCoFound = false
            }
          }
        } catch (err) {
          const { data } = err.response.data
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    assignCedBrkCo(data) {
      if (this.fieldName === 'cedBrk') {
        this.clickAssignCedBrk = true
        this.checkAssignCedBrk = true
        this.ttyHeaderForm.cedBrk = data.inter
        this.ttyHeaderForm.cedBrkDesc = data.inter + ' - ' + data.name
      } else if (this.fieldName === 'cedCo') {
        this.clickAssignCedCo = true
        this.checkAssignCedCo = true
        this.ttyHeaderForm.cedCo = data.inter
        this.ttyHeaderForm.cedCoDesc = data.inter + ' - ' + data.name
      }
    },
    checkTtyRef() {
      this.checkAssignTtyRef = false
      if (this.clickAssignTtyRef) {
        this.checkAssignTtyRef = true
      } else {
        this.checkAssignTtyRef = false
        this.getTtyRef()
      }
      this.clickAssignTtyRef = false
    },
    async getTtyRef() {
      const apiUrl = this.menu.getTop1TreatyDetByTtyNo
      if (apiUrl) {
        try {
          const expand = {
            riType: 'O',
            ttyRef: this.ttyHeaderForm.ttyRef
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          const { data } = result.data
          if (data) {
            if (data.treatyDet !== null) {
              this.ttyRefFound = true
              this.ttyHeaderForm.ttyRef = data.treatyDet.ttyNo
              this.ttyHeaderForm.ttyDesc = data.treatyDet.ttyName
              this.ttyHeaderForm.uwYr = data.treatyDet.uwYr
              this.getStmtTypeDropList()
            } else {
              this.ttyRefFound = false
            }
          } else {
            this.ttyRefFound = false
          }
        } catch (err) {
          const { data } = err.response.data
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    assignTtyRef(data) {
      this.clickAssignTtyRef = true
      this.checkAssignTtyRef = true
      this.ttyHeaderForm.ttyRef = data.ttyNo
      this.ttyHeaderForm.ttyDesc = data.ttyName
      this.ttyHeaderForm.uwYr = data.uwYr
      this.getStmtTypeDropList()
    },
    async getStmtTypeDropList() {
      // When ttyRef change, and found in treatyDet table, update stmtTypeList
      if (this.ttyHeaderForm.ttyRef !== undefined && this.ttyHeaderForm.ttyRef !== '') {
        const apiUrl = this.menu.getStmtTypeDropList
        if (apiUrl) {
          try {
            const expand = {
              riType: 'O', // KIV: Value get from previous page calling program
              ttyNo: this.ttyHeaderForm.ttyRef,
              uwYr: this.ttyHeaderForm.uwYr
            }
            const result = await this.$http.get(expandURI(apiUrl, expand))
            if (result.data.dataList) {
              this.$set(this, 'stmtTypeList', result.data.dataList)
            } else {
              this.$set(this, 'stmtTypeList', [])
            }
          } catch (err) {
            const { data } = err.response.data
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          }
        } else {
          this.errorMessage('The request failed because it is trying to execute an invalid API url.')
        }
      }
    },
    // async assignAllRI() {
    //   const apiUrl = this.menu.getStmtType
    //   if (apiUrl) {
    //     try {
    //       const expand = {
    //         riType: this.ttyHeaderForm.riType,
    //         stmtType: this.ttyHeaderForm.stmtType
    //       }
    //       const result = await this.$http.get(expandURI(apiUrl, expand))
    //       const { data } = result.data
    //       if (data) {
    //         this.ttyHeaderForm.allRI = data.defALLRI
    //       }
    //     } catch (err) {
    //       const { data } = err.response.data
    //       if (data) {
    //         this.message(data)
    //         this.fieldMessage(data)
    //       }
    //     }
    //   }
    // },
    async assignAllRI(value) {
      this.stmtTypeList.map((item) => {
        if (item.value === value) {
          this.stmtTypeDateType = item.thirdValue
          if (item.secondaryValue === true) {
            this.ttyHeaderForm.allRI = 'true'
          } else {
            this.ttyHeaderForm.allRI = 'false'
          }
        }
      })
    },
    async checkTranDate() {
      const apiUrl = this.menu.checkTranDate
      if (apiUrl) {
        try {
          const expand = {
            riType: 'O',
            tranDate: formatDisplayDateTime2(this.ttyHeaderForm.tranDate)
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          const { data } = result.data
          if (data) {
            if (data.tranDateRange !== null) {
              this.tranDateFrm = data.tranDateRange.fromDate
              this.tranDateTo = data.tranDateRange.toDate
            }
            if (data.acctPeriod !== null) {
              this.acctPeriodFound = true
              this.ttyHeaderForm.acctMth = data.acctPeriod.acctPerMth
              this.ttyHeaderForm.acctYr = data.acctPeriod.acctPerYr
            } else {
              this.acctPeriodFound = false
            }
          }
        } catch (err) {
          const { data } = err.response.data
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async checkAcctPerStDate() {
      if (this.stmtTypeDateType === 'A') {
        this.ttyHeaderForm.acctPerEndDate = this.ttyHeaderForm.acctPerStDate
      } else if (this.stmtTypeDateType === 'P') {
        this.ttyHeaderForm.acctPerEndDate = undefined
      }
    },
    async checkAcctPerEndDate() {
      const apiUrl = this.menu.checkAcctPerEndDate
      if (apiUrl) {
        try {
          const expand = {
            riType: 'O',
            ttyRef: this.ttyHeaderForm.ttyRef,
            acctPerEndDate: formatDisplayDateTime2(this.ttyHeaderForm.acctPerEndDate)
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          const { data } = result.data
          if (data) {
            if (data.treatyDet !== null) {
              if (!isAfter(removeTime(data.treatyDet.expDate), removeTime(this.ttyHeaderForm.acctPerEndDate))) {
                this.acctPerEndDateFound = false
              } else {
                this.acctPerEndDateFound = true
              }
              this.ttyDetExpDate = data.treatyDet.expDate
            }
            if (data.treatyPeriod !== null) {
              // console.log(data.treatyPeriod)
              this.ttyHeaderForm.ttyYr = data.treatyPeriod.id.ttyYr
            } else {
              this.ttyHeaderForm.ttyYr = this.ttyHeaderForm.uwYr
            }
          }
        } catch (err) {
          const { data } = err.response.data
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    assignCurrencyInfo(data) {
      this.ttyHeaderForm.curr = data.curr
      this.ttyHeaderForm.currRate = data.currRate
    },
    doCancel() {
      this.$router.push({ name: 'mngTreatyList' })
    },
    async doSave() {
      this.resetMessages()
      let result3
      await this.$validator.validateAll().then((result2) => {
        if (result2) {
          if (this.newMode) {
            this.doCreate()
          } else if (this.reviewMode) {
            this.doUpdate()
          }
          result3 = true
        } else {
          this.promptFieldCheck()
          this.checkSave = false
          result3 = false
        }
        // }).then(result3 => {
        //   if (result3) {
        //     this.getTtyStmtLnList(this.ttyHeaderForm)
        //     this.key = 1
        //   }
      })
      return result3
    },
    doRelease() {
      this.releaseStmt()
    },
    doProceed() {
      this.proceed = true
      // this.resetMessages()
      // this.$validator.validateAll().then(result2 => {
      //   console.log(result2)
      //   if (result2) {
      //     console.log(this.checkSave)
      //     if (this.newMode) {
      //       this.doCreate()
      //     } else if (this.reviewMode) {
      //       this.doUpdate()
      //     }
      //     return true
      //   } else {
      //     this.promptFieldCheck()
      //     return false
      //   }
      // }).then(resutl3 => {
      //   if (result3) {
      //     this.getTtyStmtLnList(this.ttyHeaderForm)
      //     this.key = 1
      //   }
      // })
      if (this.newMode) {
        this.$validator.validateAll().then((result) => {
          if (result) {
            this.doCreate().then((result1) => {
              if (result1) {
                this.loadingFlag = true
                // this.selectedTty.riType = result1.riType
                // this.selectedTty.stmtType = result1.stmtType
                // this.selectedTty.tranDate = result1.tranDate
                // this.selectedTty.tranRef = result1.tranRef
                // this.selectedTty.ttyRef = result1.ttyRef
                // this.selectedTty.uwYr = result1.uwYr
                // this.selectedTty.acctMth = result1.acctMth
                // this.selectedTty.acctYr = result1.acctYr
                this.ttyHeaderForm.tranRef = result1.tranRef
                this.doCreateTtyStmtLn2(result1).then((result2) => {
                  this.key = 1
                  this.submitting = false
                  const convertList = {
                    text: '100%',
                    value: ''
                  }
                  this.retroRIList.unshift(convertList)
                  this.getRetroRIList(this.ttyHeaderForm)
                  this.modeStatus = 'review'
                  this.newMode = false
                  this.reviewMode = true
                  this.queryMode = false
                  this.loadingFlag = false
                })
              }
            })
          }
        })
      } else if (this.reviewMode) {
        this.loadingFlag = true
        this.doUpdate().then((result1) => {
          if (result1) {
            this.doCreateTtyStmtLn2(result1).then((result2) => {
              this.loadingFlag = false
              this.key = 1
              this.submitting = false
            })
          }
        })
      }
      this.submitting = false
      // this.doSave().then(result1 => {
      //   if (result1) {
      //     this.doCreateTtyStmtLn2(this.ttyHeaderForm).then(result2 => {
      //       this.key = 1
      //     })
      //     // this.doColumn('ttyStmtLn')
      //     // this.getTtyStmtLnList(this.ttyHeaderForm)
      //   }
      // })
    },
    async doCreate() {
      const apiUrl = this.menu.createTtyMaster
      if (apiUrl) {
        this.submitting = true
        try {
          const result = await this.$http.post(apiUrl, this.ttyHeaderForm)
          const { data } = result
          if (data) {
            this.notify(data)
            if (this.proceed) {
              this.proceed = false
              return data
            } else {
              this.$router.push({ name: 'mngTreatyList' })
            }
          }
        } catch (err) {
          this.submitting = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
      this.submitting = false
    },
    async doUpdate() {
      const apiUrl = this.menu.updateTtyMaster
      if (apiUrl) {
        this.submitting = true
        try {
          const result = await this.$http.put(apiUrl, this.ttyHeaderForm)
          const { data } = result
          if (data) {
            this.notify(data)
            if (this.proceed) {
              this.proceed = false
              return data
            } else {
              this.$router.push({ name: 'mngTreatyList' })
            }
          }
        } catch (err) {
          this.submitting = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
      this.submitting = false
    },
    async doSaveTtyStmtLn() {
      await this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.newModeTtyStmtLn) {
            this.doCreateTtyStmtLn()
          } else if (this.reviewModeTtyStmtLn) {
            this.doUpdateTtyStmtLn()
          }
        } else {
          this.promptFieldCheck()
          this.checkSave = false
        }
      })
    },
    doNew() {
      this.stmtLnSeqExist = false
      this.ttyStmtLnReview = false
      this.newModeTtyStmtLn = true
      this.reviewModeTtyStmtLn = false
      this.queryMode = false
      this.queryModeTtyStmtLn = false
      this.showTtyStmtLn = true
      if (this.ttyStmtLnForm.riRef !== undefined && this.ttyStmtLnForm.brkRef !== undefined) {
        this.getCedCoCedBrk(this.ttyHeaderForm, this.ttyStmtLnForm)
      }
      if (this.ttyHeaderForm.riType === 'O') {
        this.ttyStmtLnForm.riRef = ''
      } else {
        this.ttyStmtLnForm.riRef = ''
      }
      this.ttyStmtLnForm.riType = this.ttyHeaderForm.riType
      this.ttyStmtLnForm.uwYr = this.ttyStmtLnForm.retroRiRefUwYr
      this.ttyStmtLnForm.ttyRef = this.ttyHeaderForm.ttyRef
      this.ttyStmtLnForm.tranDate = this.ttyHeaderForm.tranDate
      this.ttyStmtLnForm.tranRef = this.ttyHeaderForm.tranRef
      this.ttyStmtLnForm.acctNoSfx = ''
      this.ttyStmtLnForm.brkRef = ''
      this.ttyStmtLnForm.stmtType = undefined
      this.ttyStmtLnForm.acctYr = this.ttyHeaderForm.acctYr
      this.ttyStmtLnForm.acctMth = this.ttyHeaderForm.acctMth
      this.ttyStmtLnForm.acctPerEndDate = this.ttyHeaderForm.acctPerEndDate
      this.ttyStmtLnForm.stmtLnType = ''
      this.ttyStmtLnForm.stmtLnTypeDesc = ''
      this.ttyStmtLnForm.stmtLnSeq = ''
      this.ttyStmtLnForm.busAn = ''
      this.ttyStmtLnForm.busAnDesc = ''
      this.ttyStmtLnForm.createdProgID = 'TreatyHeader'
      this.ttyStmtLnForm.amtA = 0
      this.ttyStmtLnForm.aedA = true
      this.ttyStmtLnForm.amt1A = 0
      this.ttyStmtLnForm.amt2A = 0
      this.ttyStmtLnForm.amt3A = 0
      this.ttyStmtLnForm.amt4A = 0
      this.ttyStmtLnForm.amt5A = 0
      this.ttyStmtLnForm.amt6A = 0
      this.ttyStmtLnForm.amt1ALoc = 0
      this.ttyStmtLnForm.amt2ALoc = 0
      this.ttyStmtLnForm.amt3ALoc = 0
      this.ttyStmtLnForm.amt4ALoc = 0
      this.ttyStmtLnForm.amt5ALoc = 0
      this.ttyStmtLnForm.amt6ALoc = 0
      this.ttyStmtLnForm.amtB = 0
      this.ttyStmtLnForm.aedB = true
      this.ttyStmtLnForm.amt1B = 0
      this.ttyStmtLnForm.amt2B = 0
      this.ttyStmtLnForm.amt3B = 0
      this.ttyStmtLnForm.amt4B = 0
      this.ttyStmtLnForm.amt5B = 0
      this.ttyStmtLnForm.amt6B = 0
      this.ttyStmtLnForm.amt1BLoc = 0
      this.ttyStmtLnForm.amt2BLoc = 0
      this.ttyStmtLnForm.amt3BLoc = 0
      this.ttyStmtLnForm.amt4BLoc = 0
      this.ttyStmtLnForm.amt5BLoc = 0
      this.ttyStmtLnForm.amt6BLoc = 0
      this.ttyStmtLnForm.amtC = 0
      this.ttyStmtLnForm.aedC = true
      this.ttyStmtLnForm.amt1C = 0
      this.ttyStmtLnForm.amt2C = 0
      this.ttyStmtLnForm.amt3C = 0
      this.ttyStmtLnForm.amt4C = 0
      this.ttyStmtLnForm.amt5C = 0
      this.ttyStmtLnForm.amt6C = 0
      this.ttyStmtLnForm.amt1CLoc = 0
      this.ttyStmtLnForm.amt2CLoc = 0
      this.ttyStmtLnForm.amt3CLoc = 0
      this.ttyStmtLnForm.amt4CLoc = 0
      this.ttyStmtLnForm.amt5CLoc = 0
      this.ttyStmtLnForm.amt6CLoc = 0
    },
    doReviewTtyStmtLn(data) {
      this.stmtLnSeqExist = false
      this.newModeTtyStmtLn = false
      this.reviewModeTtyStmtLn = true
      this.queryMode = false
      this.queryModeTtyStmtLn = false
      this.ttyStmtLnReview = true
      this.showTtyStmtLn = true
      this.doFetchTtyStmtLn(data)
    },
    doQueryTtyStmtLn(data) {
      this.stmtLnSeqExist = false
      this.newModeTtyStmtLn = false
      this.reviewModeTtyStmtLn = false
      // this.queryMode = true
      this.queryModeTtyStmtLn = true
      this.ttyStmtLnReview = true
      this.showTtyStmtLn = true
      this.doFetchTtyStmtLn(data)
    },
    getTtyStmtLnListByRetroRiRef() {
      this.showTtyStmtLn = false
      this.getTtyStmtLnList(this.ttyHeaderForm)
    },
    getTtyStmtLnListByRetroRiRefUwYr() {
      this.showTtyStmtLn = false
      if (this.ttyStmtLnForm.retroRiRefUwYr === 'New') {
        this.showRetroRiUwYrNew = true
        this.ttyHeaderForm.retroRiRefNewUwYr = this.ttyHeaderForm.uwYr.toString()
        // this.createTtyStmtLnUwYr()
      } else {
        this.getTtyStmtLnList(this.ttyHeaderForm)
      }
    },
    closeRetroRiUwYrNew() {
      this.showRetroRiUwYrNew = false
      this.ttyStmtLnForm.retroRiRefUwYr = this.ttyHeaderForm.uwYr.toString()
      // this.ttyStmtLnForm.retroRiRefUwYr = this.retroRIUwYrList[0].value
    },
    defaultRetroList(convertList) {
      this.retroRIList.unshift(convertList).then(result => {
        if (result) {
          return true
        } else {
          return false
        }
      })
    },
    async getBusAnList () {
      const apiURI = this.menu.getBusAnList
      if (apiURI) {
        try {
          const expand = {
            riType: this.ttyHeaderForm.riType,
            ttyRef: this.ttyHeaderForm.ttyRef,
            uwYr: this.ttyStmtLnForm.retroRiRefUwYr
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          if (result) {
            this.busAnList = [ { value: '', label: '' } ]
            const { data } = result.data
            this.busAnList = data
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    doAssignBusCls(selected) {
      this.ttyStmtLnForm.busAn = selected.value
      this.ttyStmtLnForm.busAnDesc = selected.secondaryValue
    },
    async createTtyStmtLnUwYr() {
      const apiUrl = this.menu.createTtyStmtLnUwYr
      if (apiUrl) {
        this.submitting = true
        try {
          const params = {
            riRef: this.ttyStmtLnForm.retroRiRef,
            riType: this.ttyHeaderForm.riType,
            ttyRef: this.ttyHeaderForm.ttyRef,
            tranRef: this.ttyHeaderForm.tranRef,
            uwYr: this.ttyHeaderForm.uwYr,
            retroRiRefNewUwYr: this.ttyHeaderForm.retroRiRefNewUwYr
          }
          const result = await this.$http.post(expandURI(apiUrl, params))
          // const result = await this.$http.post(apiUrl, this.ttyHeaderForm)
          const data = result.data
          if (data) {
            this.notify(data)
            if (data.messages[0].type === 'ERROR') {
              this.ttyStmtLnForm.retroRiRefUwYr = this.ttyStmtLnForm.retroRiRefUwYr
            } else {
              this.ttyStmtLnForm.retroRiRefUwYr = this.ttyHeaderForm.uwYr.toString()
              this.getRetroRIUwYrList(this.ttyHeaderForm)
              this.getTtyStmtLnListByRetroRiRefUwYr()
            }
            // this.getTtyStmtLnList(this.ttyHeaderForm)
          }
          this.showRetroRiUwYrNew = false
        } catch (err) {
          this.submitting = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
        this.submitting = false
      }
    },
    doColumn(riTab, ttyHeaderForm) {
      this.tab = undefined
      this.columns = []
      if (riTab === 'ttyStmtLn') {
        this.tab = 'ttyStmtLn'
        this.columns = Object.assign(this.columns, this.ttyStmtLnColumns)
      }
      // console.log(this.ttyStmtLnForm)
      // console.log(this.retroRIList)
      // this.getTtyStmtLnList(this.ttyHeaderForm)
      // this.getCedCoCedBrk(this.ttyHeaderForm, this.ttyStmtLnForm)
      // if (this.retroRIList.length === 1) {
      //   console.log(this.retroRIList.length)
      //   this.getRetroRIList(ttyHeaderForm)
      // }
      // if (this.ttyHeaderForm.ttyRef !== '' && this.ttyHeaderForm.ttyRef !== undefined) {
      //   console.log('doColumn')
      //   this.getTtyStmtLnList(this.ttyHeaderForm)
      //   if (this.ttyStmtLnForm.riRef !== undefined && this.ttyStmtLnForm.brkRef !== undefined) {
      //     this.getCedCoCedBrk(this.ttyHeaderForm, this.ttyStmtLnForm)
      //   }
      // }
    },
    async getMiscTreatyParam() {
      const apiUrl = this.menu.getMiscTreatyParam
      if (apiUrl) {
        try {
          const result = await this.$http.get(apiUrl)
          const { data } = result.data
          if (data) {
            this.miscTreatyParam.perSuspTran = data.miscTreaty.perSuspTran
            this.miscTreatyParam.perDebtTran = data.miscTreaty.perDebtTran
            // this.miscTreatyParam.nxtInwTranRef = data.miscTreaty.nxtInwTranRef
            // this.miscTreatyParam.nxtOutwTranRef = data.miscTreaty.nxtOutwTranRef
          }
        } catch (err) {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async getTtyStmtLnList(ttyHeaderForm) {
      const apiUrl = this.menu.treatyStmtLnList2
      if (apiUrl) {
        try {
          this.loading = true
          this.showTtyStmtLn = false
          this.ttyStmtLnList = []
          const { page, itemsPerPage } = this.paginationTtyStmtLn
          const expand = {
            page: page - 1,
            size: itemsPerPage,
            riRef: this.ttyStmtLnForm.retroRiRef,
            riType: ttyHeaderForm.riType,
            ttyRef: ttyHeaderForm.ttyRef,
            tranRef: ttyHeaderForm.tranRef,
            uwYr: (this.ttyStmtLnForm.retroRiRefUwYr === '' || this.ttyStmtLnForm.retroRiRefUwYr === undefined & this.ttyStmtLnForm.retroRiRefUwYr !== 'New') ? ttyHeaderForm.uwYr : this.ttyStmtLnForm.retroRiRefUwYr
          }
          const result = await this.$http.get(
            filterQuery(expandURI(apiUrl, expand), this.ttyStmtLnFilter, this.paginationTtyStmtLn.sortBy, this.paginationTtyStmtLn.sortDesc)
          )
          if (result.data) {
            this.stmtTypeCheck1 = false
            // console.log(result.data.stmtTypeCheck1)
            if (result.data.stmtTypeCheck1) {
              this.stmtTypeCheck1 = true
            }
            this.totalItemsTtyStmtLn = result.data.totalElements
            const { data } = result.data
            if (data) {
              data.map((ttyStmtLn) => {
                const convertTtyStmtLn = {
                  riType: ttyStmtLn.riType,
                  ttyRef: ttyStmtLn.ttyRef,
                  stmtType: ttyStmtLn.stmtType,
                  tranDate: ttyStmtLn.tranDate,
                  tranDateDisp: this.formatDate(ttyStmtLn.tranDate),
                  acctYr: ttyStmtLn.acctyr,
                  acctMth: ttyStmtLn.acctMth,
                  riRef: ttyStmtLn.riRef,
                  brkRef: ttyStmtLn.brkRef,
                  uwYr: ttyStmtLn.uwYr,
                  stmtLnType: ttyStmtLn.stmtLnType,
                  stmtLnSeq: ttyStmtLn.stmtLnSeq,
                  busAn: ttyStmtLn.busAn,
                  busAnDesc: ttyStmtLn.busAnDesc,
                  tranRef: ttyStmtLn.tranRef,
                  amtA: formatPrice(ttyStmtLn.amtA),
                  aedA: ttyStmtLn.aedA,
                  aedADisp: formatYesNo(ttyStmtLn.aedA),
                  amt1A: formatPrice(ttyStmtLn.amt1A),
                  amt2A: formatPrice(ttyStmtLn.amt2A),
                  amt3A: formatPrice(ttyStmtLn.amt3A),
                  amt4A: formatPrice(ttyStmtLn.amt4A),
                  amt5A: formatPrice(ttyStmtLn.amt5A),
                  amt6A: formatPrice(ttyStmtLn.amt6A),
                  acctNoSfx: ttyStmtLn.acctNoSfx
                }
                if (convertTtyStmtLn.busAn === undefined) {
                  convertTtyStmtLn.busAn = ''
                }
                // console.log(this.ttyStmtLnList)
                this.ttyStmtLnList.push(convertTtyStmtLn)
              })
              this.checkTtyStmtLnList = true
              this.loading = false
              return true
            } else {
              this.loading = false
              this.ttyStmtLnList = []
            }
            // this.$store.commit(TTY_STMT_LN, this.ttyStmtLnList)
            this.loading = false
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.ttyStmtLnForm.retroRiRefUwYr = this.ttyHeaderForm.uwYr.toString()
            this.message(data)
          }
          this.loading = false
        }
      }
    },
    async getCedCoCedBrk(ttyHeader, ttyStmtLn) {
      const apiUrl = this.menu.getCedCoCedBrk
      if (apiUrl) {
        try {
          const params = {
            riType: ttyHeader.riType,
            ttyRef: ttyHeader.ttyRef,
            uwYr: ttyHeader.uwYr,
            riRef: ttyStmtLn.riRef,
            brkRef: ttyStmtLn.brkRef
          }
          const result = await this.$http.get(expandURI(apiUrl, params))
          const { data } = result.data
          if (data) {
            // console.log(data)
          }
        } catch (err) {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async getRetroRIList(ttyHeader) {
      const apiUrl = this.menu.getRetroRIList
      if (apiUrl) {
        try {
          const expand = {
            riType: ttyHeader.riType,
            ttyRef: ttyHeader.ttyRef,
            uwYr: ttyHeader.uwYr
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          if (result.data.dataList) {
            result.data.dataList.map((retroRI) => {
              const convertList = {
                text: retroRI.label,
                value: retroRI.value
              }
              this.retroRIList.push(convertList)
            })
            this.ttyStmtLnForm.retroRiRef = this.retroRIList[0].value
            // this.retroRIList.push(result.data.dataList)
            // this.$push(this, 'retroRIList', result.data.dataList)
          }
        } catch (err) {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async getRetroRIUwYrList(ttyHeader) {
      const apiUrl = this.menu.getRetroRIUwYrList
      if (apiUrl) {
        try {
          const expand = {
            riType: ttyHeader.riType,
            ttyRef: ttyHeader.ttyRef,
            tranRef: ttyHeader.tranRef
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          if (result.data.dataList) {
            result.data.dataList.map((retroRIUwYr) => {
              const convertList = {
                text: retroRIUwYr.label,
                value: parseInt(retroRIUwYr.value)
              }
              this.retroRIUwYrList.unshift(convertList)
            })
            this.ttyStmtLnForm.retroRiRefUwYr = this.ttyStmtLnForm.retroRiRefUwYr
            // this.retroRIList.push(result.data.dataList)
            // this.$push(this, 'retroRIList', result.data.dataList)
          }
        } catch (err) {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async doFetchTtyStmtLn(ttyStmtLn) {
      const apiUrl = this.menu.getTtyStmtLnDetail
      if (apiUrl) {
        try {
          const params = {
            riType: ttyStmtLn.riType,
            ttyRef: ttyStmtLn.ttyRef,
            stmtType: ttyStmtLn.stmtType,
            tranDate: formatDisplayDateTime2(ttyStmtLn.tranDate),
            riRef: ttyStmtLn.riRef,
            brkRef: ttyStmtLn.brkRef,
            uwYr: ttyStmtLn.uwYr,
            stmtLnType: ttyStmtLn.stmtLnType,
            busAn: ttyStmtLn.busAn,
            tranRef: ttyStmtLn.tranRef
          }
          const result = await this.$http.get(expandURI(apiUrl, params))
          const { data } = result.data
          if (data) {
            this.ttyStmtLnForm.riType = data.ttyStmtLn.riType
            this.ttyStmtLnForm.ttyRef = data.ttyStmtLn.ttyRef
            this.ttyStmtLnForm.stmtType = data.ttyStmtLn.stmtType
            this.ttyStmtLnForm.tranDate = data.ttyStmtLn.tranDate
            this.ttyStmtLnForm.tranRef = data.ttyStmtLn.tranRef
            if (data.ttyStmtLn.riRef === undefined) {
              this.ttyStmtLnForm.riRef = ''
            } else {
              this.ttyStmtLnForm.riRef = data.ttyStmtLn.riRef
            }
            if (data.ttyStmtLn.brkRef === undefined) {
              this.ttyStmtLnForm.brkRef = ''
            } else {
              this.ttyStmtLnForm.brkRef = data.ttyStmtLn.brkRef
            }
            this.ttyStmtLnForm.acctNoSfx = data.ttyStmtLn.acctNoSfx
            this.ttyStmtLnForm.uwYr = data.ttyStmtLn.uwYr
            this.ttyStmtLnForm.acctMth = data.ttyStmtLn.acctMth
            this.ttyStmtLnForm.acctYr = data.ttyStmtLn.acctYr
            this.ttyStmtLnForm.stmtLnType = data.ttyStmtLn.stmtLnType
            this.ttyStmtLnForm.stmtLnTypeDesc = data.ttyStmtLn.stmtLnTypeDesc
            this.ttyStmtLnForm.stmtLnSeq = data.ttyStmtLn.stmtLnSeq
            if (data.ttyStmtLn.busAn === undefined) {
              this.ttyStmtLnForm.busAn = ''
            } else {
              this.ttyStmtLnForm.busAn = data.ttyStmtLn.busAn
            }
            this.ttyStmtLnForm.busAnDesc = data.ttyStmtLn.busAnDesc
            this.ttyStmtLnForm.amtA = formatPrice(data.ttyStmtLn.amtA)
            this.ttyStmtLnForm.aedA = data.ttyStmtLn.aedA
            this.ttyStmtLnForm.amt1A = formatPrice(data.ttyStmtLn.amt1A)
            this.ttyStmtLnForm.amt2A = formatPrice(data.ttyStmtLn.amt2A)
            this.ttyStmtLnForm.amt3A = formatPrice(data.ttyStmtLn.amt3A)
            this.ttyStmtLnForm.amt4A = formatPrice(data.ttyStmtLn.amt4A)
            this.ttyStmtLnForm.amt5A = formatPrice(data.ttyStmtLn.amt5A)
            this.ttyStmtLnForm.amt6A = formatPrice(data.ttyStmtLn.amt6A)
            this.ttyStmtLnForm.amt1ALoc = formatPrice(data.ttyStmtLn.amt1ALoc)
            this.ttyStmtLnForm.amt2ALoc = formatPrice(data.ttyStmtLn.amt2ALoc)
            this.ttyStmtLnForm.amt3ALoc = formatPrice(data.ttyStmtLn.amt3ALoc)
            this.ttyStmtLnForm.amt4ALoc = formatPrice(data.ttyStmtLn.amt4ALoc)
            this.ttyStmtLnForm.amt5ALoc = formatPrice(data.ttyStmtLn.amt5ALoc)
            this.ttyStmtLnForm.amt6ALoc = formatPrice(data.ttyStmtLn.amt6ALoc)
            this.ttyStmtLnForm.amtB = formatPrice(data.ttyStmtLn.amtB)
            this.ttyStmtLnForm.aedB = data.ttyStmtLn.aedB
            this.ttyStmtLnForm.amt1B = formatPrice(data.ttyStmtLn.amt1B)
            this.ttyStmtLnForm.amt2B = formatPrice(data.ttyStmtLn.amt2B)
            this.ttyStmtLnForm.amt3B = formatPrice(data.ttyStmtLn.amt3B)
            this.ttyStmtLnForm.amt4B = formatPrice(data.ttyStmtLn.amt4B)
            this.ttyStmtLnForm.amt5B = formatPrice(data.ttyStmtLn.amt5B)
            this.ttyStmtLnForm.amt6B = formatPrice(data.ttyStmtLn.amt6B)
            this.ttyStmtLnForm.amt1BLoc = formatPrice(data.ttyStmtLn.amt1BLoc)
            this.ttyStmtLnForm.amt2BLoc = formatPrice(data.ttyStmtLn.amt2BLoc)
            this.ttyStmtLnForm.amt3BLoc = formatPrice(data.ttyStmtLn.amt3BLoc)
            this.ttyStmtLnForm.amt4BLoc = formatPrice(data.ttyStmtLn.amt4BLoc)
            this.ttyStmtLnForm.amt5BLoc = formatPrice(data.ttyStmtLn.amt5BLoc)
            this.ttyStmtLnForm.amt6BLoc = formatPrice(data.ttyStmtLn.amt6BLoc)
            this.ttyStmtLnForm.amtC = formatPrice(data.ttyStmtLn.amtC)
            this.ttyStmtLnForm.aedC = data.ttyStmtLn.aedC
            this.ttyStmtLnForm.amt1C = formatPrice(data.ttyStmtLn.amt1C)
            this.ttyStmtLnForm.amt2C = formatPrice(data.ttyStmtLn.amt2C)
            this.ttyStmtLnForm.amt3C = formatPrice(data.ttyStmtLn.amt3C)
            this.ttyStmtLnForm.amt4C = formatPrice(data.ttyStmtLn.amt4C)
            this.ttyStmtLnForm.amt5C = formatPrice(data.ttyStmtLn.amt5C)
            this.ttyStmtLnForm.amt6C = formatPrice(data.ttyStmtLn.amt6C)
            this.ttyStmtLnForm.amt1CLoc = formatPrice(data.ttyStmtLn.amt1CLoc)
            this.ttyStmtLnForm.amt2CLoc = formatPrice(data.ttyStmtLn.amt2CLoc)
            this.ttyStmtLnForm.amt3CLoc = formatPrice(data.ttyStmtLn.amt3CLoc)
            this.ttyStmtLnForm.amt4CLoc = formatPrice(data.ttyStmtLn.amt4CLoc)
            this.ttyStmtLnForm.amt5CLoc = formatPrice(data.ttyStmtLn.amt5CLoc)
            this.ttyStmtLnForm.amt6CLoc = formatPrice(data.ttyStmtLn.amt6CLoc)
          }
        } catch (err) {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    getStmtLnTypeDropList() {},
    assignStmtLineType(data) {
      this.ttyStmtLnForm.stmtLnType = data.stmtLnType
      this.ttyStmtLnForm.stmtLnTypeDesc = data.stmtLnDesc1
      this.ttyStmtLnForm.stmtLnSeq = data.stmtLnSeq
      this.checkStmtLnBusAn()
    },
    async checkStmtLnBusAn() {
      const apiUrl = this.menu.getStmtLnBusAnByTtyStmtLn
      if (apiUrl) {
        try {
          const expand = {
            riType: this.ttyStmtLnForm.riType,
            ttyRef: this.ttyStmtLnForm.ttyRef,
            stmtLnType: this.ttyStmtLnForm.stmtLnType,
            uwYr: this.ttyStmtLnForm.uwYr
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          const { data } = result.data
          if (result.data) {
            if (data.stmtLnBusAn.busAn === undefined) {
              this.ttyStmtLnForm.busAn = ''
            } else {
              this.ttyStmtLnForm.busAn = data.stmtLnBusAn.busAn
            }
            this.ttyStmtLnForm.busAnDesc = data.stmtLnBusAn.busAnLongDesc
          }
        } catch (err) {
          this.submitting = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async doCreateTtyStmtLn() {
      const apiUrl = this.menu.createTtyStmtLn
      if (apiUrl) {
        this.submitting = true
        try {
          this.doRemoveFormat()
          const result = await this.$http.post(apiUrl, this.ttyStmtLnForm)
          const data = result.data
          if (data) {
            this.notify(data)
            if (data.messages[0].type === 'ERROR') {
              this.stmtLnSeqExist = true
            } else {
              this.stmtLnSeqExist = false
            }
            this.getTtyStmtLnList(this.ttyHeaderForm)
          }
        } catch (err) {
          this.submitting = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
        this.submitting = false
      }
    },
    async doUpdateTtyStmtLn() {
      const apiUrl = this.menu.updateTtyStmtLn
      if (apiUrl) {
        this.submitting = true
        this.doRemoveFormat()
        try {
          const result = await this.$http.put(apiUrl, this.ttyStmtLnForm)
          const data = result.data
          if (data) {
            this.notify(data)
            this.getTtyStmtLnList(this.ttyHeaderForm)
          }
        } catch (err) {
          this.submitting = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
        this.submitting = false
      }
    },
    async doCreateTtyStmtLn2(ttyHeader) {
      const apiUrl = this.menu.createTtyStmtLn2
      if (apiUrl) {
        try {
          const expand = {
            riType: ttyHeader.riType,
            ttyRef: ttyHeader.ttyRef,
            stmtType: ttyHeader.stmtType,
            tranDate: formatDisplayDateTime2(ttyHeader.tranDate),
            tranRef: ttyHeader.tranRef,
            createdProgID: ttyHeader.createdProgID
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          const { data } = result.data
          if (data) {
            // console.log(data)
            this.newMode = false
            this.reviewMode = true
            this.queryMode = false
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    doPromptRemoveTtyStmtLn(item) {
      this.promptRemove = true
      this.ttyStmtLnlabels.promptRemoveTtyStmtLn =
        'You have chosen to delete this record, RIType: ' +
        item.riType +
        ' TreatyRef: ' +
        item.ttyRef +
        ' . Do you really want to delete this record?'
      this.selectedTtyStmtLn = item
      this.deleteTtyStmtLn = item.riType + ' - ' + item.ttyRef + ' - ' + item.uwYr + ' - ' + item.stmtLnType + ' - ' + item.stmtLnSeq
    },
    async doDeleteTtyStmtLn() {
      this.loadingFlag = true
      const apiUrl = this.menu.deleteTtyStmtLn
      if (apiUrl) {
        this.selectedTtyStmtLn.amtA = removeFormatNumber(this.selectedTtyStmtLn.amtA)
        this.selectedTtyStmtLn.amt1A = removeFormatNumber(this.selectedTtyStmtLn.amt1A)
        const expand = this.selectedTtyStmtLn
        await this.$http
          .post(apiUrl, expand)
          .then((result) => {
            const data = result.data
            this.notify(data)
            this.getTtyStmtLnList(this.ttyHeaderForm)
          })
          .catch((err) => {
            const { data } = err.response
            if (data) {
              this.message(data)
            }
          })
        this.loadingFlag = false
      } else {
        this.loadingFlag = false
      }
    },
    resetStmtLnSeq() {
      this.stmtLnSeqExist = false
    },
    doCalculateCurrRate() {
      // console.log(this.ttyHeaderForm.currRate)
      // this.ttyStmtLnForm.amt1ALoc = formatPrice((this.ttyStmtLnForm.amt1A * this.ttyHeaderForm.currRate))
      this.ttyStmtLnForm.amt1ALoc = formatDisplayNumber(parseInt(removeFormatNumber(this.ttyStmtLnForm.amt1A)) * this.ttyHeaderForm.currRate, 2)
      // console.log(this.ttyStmtLnForm.amt1ALoc)
      this.ttyStmtLnForm.amt2ALoc = formatPrice(parseInt(removeFormatNumber(this.ttyStmtLnForm.amt2A)) * this.ttyHeaderForm.currRate)
      this.ttyStmtLnForm.amt3ALoc = formatPrice(parseInt(removeFormatNumber(this.ttyStmtLnForm.amt3A)) * this.ttyHeaderForm.currRate)
      this.ttyStmtLnForm.amt4ALoc = formatPrice(parseInt(removeFormatNumber(this.ttyStmtLnForm.amt4A)) * this.ttyHeaderForm.currRate)
      this.ttyStmtLnForm.amt5ALoc = formatPrice(parseInt(removeFormatNumber(this.ttyStmtLnForm.amt5A)) * this.ttyHeaderForm.currRate)
      this.ttyStmtLnForm.amt6ALoc = formatPrice(parseInt(removeFormatNumber(this.ttyStmtLnForm.amt6A)) * this.ttyHeaderForm.currRate)
      this.ttyStmtLnForm.amt1BLoc = formatPrice(parseInt(removeFormatNumber(this.ttyStmtLnForm.amt1B)) * this.ttyHeaderForm.currRate)
      this.ttyStmtLnForm.amt2BLoc = formatPrice(parseInt(removeFormatNumber(this.ttyStmtLnForm.amt2B)) * this.ttyHeaderForm.currRate)
      this.ttyStmtLnForm.amt3BLoc = formatPrice(parseInt(removeFormatNumber(this.ttyStmtLnForm.amt3B)) * this.ttyHeaderForm.currRate)
      this.ttyStmtLnForm.amt4BLoc = formatPrice(parseInt(removeFormatNumber(this.ttyStmtLnForm.amt4B)) * this.ttyHeaderForm.currRate)
      this.ttyStmtLnForm.amt5BLoc = formatPrice(parseInt(removeFormatNumber(this.ttyStmtLnForm.amt5B)) * this.ttyHeaderForm.currRate)
      this.ttyStmtLnForm.amt6BLoc = formatPrice(parseInt(removeFormatNumber(this.ttyStmtLnForm.amt6B)) * this.ttyHeaderForm.currRate)
      this.ttyStmtLnForm.amt1CLoc = formatPrice(parseInt(removeFormatNumber(this.ttyStmtLnForm.amt1C)) * this.ttyHeaderForm.currRate)
      this.ttyStmtLnForm.amt2CLoc = formatPrice(parseInt(removeFormatNumber(this.ttyStmtLnForm.amt2C)) * this.ttyHeaderForm.currRate)
      this.ttyStmtLnForm.amt3CLoc = formatPrice(parseInt(removeFormatNumber(this.ttyStmtLnForm.amt3C)) * this.ttyHeaderForm.currRate)
      this.ttyStmtLnForm.amt4CLoc = formatPrice(parseInt(removeFormatNumber(this.ttyStmtLnForm.amt4C)) * this.ttyHeaderForm.currRate)
      this.ttyStmtLnForm.amt5CLoc = formatPrice(parseInt(removeFormatNumber(this.ttyStmtLnForm.amt5C)) * this.ttyHeaderForm.currRate)
      this.ttyStmtLnForm.amt6CLoc = formatPrice(parseInt(removeFormatNumber(this.ttyStmtLnForm.amt6C)) * this.ttyHeaderForm.currRate)

      this.calculateAmountA()
    },
    calculateAmountA() {
      if (this.ttyStmtLnForm.aedA) {
        // this.ttyStmtLnForm.amt1A = 0
        // this.ttyStmtLnForm.amt2A = 0
        // this.ttyStmtLnForm.amt3A = 0
        // this.ttyStmtLnForm.amt4A = 0
        // this.ttyStmtLnForm.amt5A = 0
        // this.ttyStmtLnForm.amt6A = 0
        // this.ttyStmtLnForm.amt1ALoc = 0
        // this.ttyStmtLnForm.amt2ALoc = 0
        // this.ttyStmtLnForm.amt3ALoc = 0
        // this.ttyStmtLnForm.amt4ALoc = 0
        // this.ttyStmtLnForm.amt5ALoc = 0
        // this.ttyStmtLnForm.amt6ALoc = 0
      } else {
        this.ttyStmtLnForm.amtA = 0
        this.ttyStmtLnForm.amtA = formatPrice(parseInt(removeFormatNumber(this.ttyStmtLnForm.amt1A)) + parseInt(removeFormatNumber(this.ttyStmtLnForm.amt2A)))
      }
      if (this.ttyStmtLnForm.aedB) {
        // this.ttyStmtLnForm.amt1B = 0
        // this.ttyStmtLnForm.amt2B = 0
        // this.ttyStmtLnForm.amt3B = 0
        // this.ttyStmtLnForm.amt4B = 0
        // this.ttyStmtLnForm.amt5B = 0
        // this.ttyStmtLnForm.amt6B = 0
        // this.ttyStmtLnForm.amt1BLoc = 0
        // this.ttyStmtLnForm.amt2BLoc = 0
        // this.ttyStmtLnForm.amt3BLoc = 0
        // this.ttyStmtLnForm.amt4BLoc = 0
        // this.ttyStmtLnForm.amt5BLoc = 0
        // this.ttyStmtLnForm.amt6BLoc = 0
      } else {
        this.ttyStmtLnForm.amtB = 0
        this.ttyStmtLnForm.amtB = formatPrice(parseInt(removeFormatNumber(this.ttyStmtLnForm.amt1B)) + parseInt(removeFormatNumber(this.ttyStmtLnForm.amt2B)))
      }
      if (this.ttyStmtLnForm.aedC) {
        // this.ttyStmtLnForm.amt1C = 0
        // this.ttyStmtLnForm.amt2C = 0
        // this.ttyStmtLnForm.amt3C = 0
        // this.ttyStmtLnForm.amt4C = 0
        // this.ttyStmtLnForm.amt5C = 0
        // this.ttyStmtLnForm.amt6C = 0
        // this.ttyStmtLnForm.amt1CLoc = 0
        // this.ttyStmtLnForm.amt2CLoc = 0
        // this.ttyStmtLnForm.amt3CLoc = 0
        // this.ttyStmtLnForm.amt4CLoc = 0
        // this.ttyStmtLnForm.amt5CLoc = 0
        // this.ttyStmtLnForm.amt6CLoc = 0
      } else {
        this.ttyStmtLnForm.amtC = 0
        this.ttyStmtLnForm.amtC = formatPrice(parseInt(removeFormatNumber(this.ttyStmtLnForm.amt1C)) + parseInt(removeFormatNumber(this.ttyStmtLnForm.amt2C)))
      }
    },
    doRemoveFormat() {
      this.ttyStmtLnForm.amtA = removeFormatNumber(this.ttyStmtLnForm.amtA)
      this.ttyStmtLnForm.amt1A = removeFormatNumber(this.ttyStmtLnForm.amt1A)
      this.ttyStmtLnForm.amt2A = removeFormatNumber(this.ttyStmtLnForm.amt2A)
      this.ttyStmtLnForm.amt3A = removeFormatNumber(this.ttyStmtLnForm.amt3A)
      this.ttyStmtLnForm.amt4A = removeFormatNumber(this.ttyStmtLnForm.amt4A)
      this.ttyStmtLnForm.amt5A = removeFormatNumber(this.ttyStmtLnForm.amt5A)
      this.ttyStmtLnForm.amt6A = removeFormatNumber(this.ttyStmtLnForm.amt6A)
      this.ttyStmtLnForm.amt1ALoc = removeFormatNumber(this.ttyStmtLnForm.amt1ALoc)
      this.ttyStmtLnForm.amt2ALoc = removeFormatNumber(this.ttyStmtLnForm.amt2ALoc)
      this.ttyStmtLnForm.amt3ALoc = removeFormatNumber(this.ttyStmtLnForm.amt3ALoc)
      this.ttyStmtLnForm.amt4ALoc = removeFormatNumber(this.ttyStmtLnForm.amt4ALoc)
      this.ttyStmtLnForm.amt5ALoc = removeFormatNumber(this.ttyStmtLnForm.amt5ALoc)
      this.ttyStmtLnForm.amt6ALoc = removeFormatNumber(this.ttyStmtLnForm.amt6ALoc)
      this.ttyStmtLnForm.amtB = removeFormatNumber(this.ttyStmtLnForm.amtB)
      this.ttyStmtLnForm.amt1B = removeFormatNumber(this.ttyStmtLnForm.amt1B)
      this.ttyStmtLnForm.amt2B = removeFormatNumber(this.ttyStmtLnForm.amt2B)
      this.ttyStmtLnForm.amt3B = removeFormatNumber(this.ttyStmtLnForm.amt3B)
      this.ttyStmtLnForm.amt4B = removeFormatNumber(this.ttyStmtLnForm.amt4B)
      this.ttyStmtLnForm.amt5B = removeFormatNumber(this.ttyStmtLnForm.amt5B)
      this.ttyStmtLnForm.amt6B = removeFormatNumber(this.ttyStmtLnForm.amt6B)
      this.ttyStmtLnForm.amt1BLoc = removeFormatNumber(this.ttyStmtLnForm.amt1BLoc)
      this.ttyStmtLnForm.amt2BLoc = removeFormatNumber(this.ttyStmtLnForm.amt2BLoc)
      this.ttyStmtLnForm.amt3BLoc = removeFormatNumber(this.ttyStmtLnForm.amt3BLoc)
      this.ttyStmtLnForm.amt4BLoc = removeFormatNumber(this.ttyStmtLnForm.amt4BLoc)
      this.ttyStmtLnForm.amt5BLoc = removeFormatNumber(this.ttyStmtLnForm.amt5BLoc)
      this.ttyStmtLnForm.amt6BLoc = removeFormatNumber(this.ttyStmtLnForm.amt6BLoc)
      this.ttyStmtLnForm.amtC = removeFormatNumber(this.ttyStmtLnForm.amtC)
      this.ttyStmtLnForm.amt1C = removeFormatNumber(this.ttyStmtLnForm.amt1C)
      this.ttyStmtLnForm.amt2C = removeFormatNumber(this.ttyStmtLnForm.amt2C)
      this.ttyStmtLnForm.amt3C = removeFormatNumber(this.ttyStmtLnForm.amt3C)
      this.ttyStmtLnForm.amt4C = removeFormatNumber(this.ttyStmtLnForm.amt4C)
      this.ttyStmtLnForm.amt5C = removeFormatNumber(this.ttyStmtLnForm.amt5C)
      this.ttyStmtLnForm.amt6C = removeFormatNumber(this.ttyStmtLnForm.amt6C)
      this.ttyStmtLnForm.amt1CLoc = removeFormatNumber(this.ttyStmtLnForm.amt1CLoc)
      this.ttyStmtLnForm.amt2CLoc = removeFormatNumber(this.ttyStmtLnForm.amt2CLoc)
      this.ttyStmtLnForm.amt3CLoc = removeFormatNumber(this.ttyStmtLnForm.amt3CLoc)
      this.ttyStmtLnForm.amt4CLoc = removeFormatNumber(this.ttyStmtLnForm.amt4CLoc)
      this.ttyStmtLnForm.amt5CLoc = removeFormatNumber(this.ttyStmtLnForm.amt5CLoc)
      this.ttyStmtLnForm.amt6CLoc = removeFormatNumber(this.ttyStmtLnForm.amt6CLoc)
    },
    doFormatDisplayNumber() {},
    async checkTop1TtyStmtLn() {
      const apiUrl = this.menu.getTop1TtyStmtLn
      if (apiUrl) {
        try {
          const expand = {
            riType: this.ttyHeaderForm.riType,
            ttyRef: this.ttyHeaderForm.ttyRef,
            tranDate: formatDisplayDateTime2(this.ttyHeaderForm.tranDate),
            tranRef: this.ttyHeaderForm.tranRef
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          const { data } = result.data
          if (data) {
            // console.log(this.ttyStmtLnTop1Found)
            // console.log(data.ttyStmtLn)
            if (data.ttyStmtLn !== null) {
              this.ttyStmtLnTop1Found = true
            } else {
              this.ttyStmtLnTop1Found = false
            }
          } else {
            this.ttyStmtLnTop1Found = false
          }
        } catch (err) {
          const { data } = err.response.data
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async releaseStmt() {
      const apiUrl = this.menu.releaseStmt
      if (apiUrl) {
        try {
          // console.log(this.userBranch)
          // console.log(this.ttyHeaderForm)
          const result = await this.$http.post(apiUrl, this.ttyHeaderForm)
          // const { data } = result.data
          if (result) {
            // console.log(this.ttyStmtLnTop1Found)
            // console.log(result)
            this.notify(result.data)
            this.$router.push({ name: 'mngTreatyList' })
          }
        } catch (err) {
          const { data } = err.response.data
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async getRiskAreaList() {
      const apiUrl = this.menu.getRiskAreaList
      if (apiUrl) {
        try {
          const result = await this.$http.get(apiUrl)
          if (result.data) {
            const { data } = result.data
            if (data) {
              data.riskArea.map((riskArea) => {
                this.ttyStmtLnlabels.amt1_6[this.riskAreaCount] = riskArea.riskAreaDesc
                this.riskAreaCount = this.riskAreaCount + 1
                // if (this.riskAreaCount === 1) {
                //   this.ttyStmtLnlabels.amt1 = riskArea.riskAreaDesc
                // } else if (this.riskAreaCount === 2) {
                //   this.ttyStmtLnlabels.amt2 = riskArea.riskAreaDesc
                // }
                // this.retroRIList.push(convertList)
              })
              this.updateAmtDesc(this.ttyStmtLnlabels.amt1_6)
            }
            // this.retroRIList.push(result.data.dataList)
            // this.$push(this, 'retroRIList', result.data.dataList)
          }
        } catch (err) {
          const { data } = err.response.data
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    updateAmtDesc(riskArea) {
      this.count = 0
      for (const updateHeader of riskArea) {
        this.count = this.count + 1
        var amtDesc = 'amt' + this.count + 'A'
        let findCol = this.ttyStmtLnColumns.find(a => amtDesc === a.value)
        if (findCol) {
          findCol.text = updateHeader
        }
      }
    }
  },
  computed: {
    menu() {
      return this.$store.state.treatyAcct.treatyMaster.menu
    },
    mode() {
      return this.$route.params.mode
    },
    userBranch() {
      return this.$store.state.token.userBranch
    },
    checkCedBrkValidation() {
      if (this.ttyHeaderForm.cedCo !== undefined && this.ttyHeaderForm.cedCo !== '') {
        return 'required|cedBrkValidation:' + this.cedBrkFound + ',' + this.checkAssignCedBrk + ',' + this.clickAssignCedBrk
      } else {
        return 'entry|cedBrkValidation:' + this.cedBrkFound + ',' + this.checkAssignCedBrk + ',' + this.clickAssignCedBrk
      }
    },
    checkCedCoValidation() {
      if (this.ttyHeaderForm.cedBrk !== undefined && this.ttyHeaderForm.cedBrk !== '') {
        return 'required|cedCoValidation:' + this.cedCoFound + ',' + this.checkAssignCedCo + ',' + this.clickAssignCedCo
      } else {
        return 'entry|cedCoValidation:' + this.cedCoFound + ',' + this.checkAssignCedCo + ',' + this.clickAssignCedCo
      }
    },
    checkTtyRefValidation() {
      return 'entry|ttyRefValidation:' + this.ttyRefFound + ',' + this.checkAssignTtyRef + ',' + this.clickAssignTtyRef
    },
    checkTranDateValidation() {
      return 'required|tranDateRangeValidation:' + this.tranDateFrm + ',' + this.tranDateTo + ',' + this.acctPeriodFound
    },
    checkDebtTypeValidation() {
      return (
        'required|debtTypeValidation:' + this.ttyHeaderForm.debtType + ',' + this.miscTreatyParam.perDebtTran + ',' + this.miscTreatyParam.perSuspTran
      )
    },
    checkAcctPerEndDateValidation() {
      return 'required|acctPerEndDateValidation:' + this.acctPerEndDateFound + ',' + formatDisplayDate(this.ttyDetExpDate)
    },
    checkStmtLnSeq() {
      return 'required|stmtLnSeqValidation:' + this.stmtLnSeqExist
    },
    riBrkRefCheck() {
      if (this.ttyStmtLnForm.riRef !== '' || this.ttyStmtLnForm.brkRef !== '') {
        return 'required'
      } else {
        return 'entry'
      }
    },
    debtTypeList() {
      let result = []
      Object.keys(debtSuspTrans).forEach(function (key) {
        const status = debtSuspTrans[key]
        result.push({
          label: status,
          value: key
        })
      })
      return result
    },
    allRIList() {
      let result = []
      Object.keys(allRI).forEach(function (key) {
        const status = allRI[key]
        result.push({
          label: status,
          value: key
        })
      })
      return result
    },
    instalNoList() {
      let result = []
      Object.keys(instalNo).forEach(function (key) {
        const status = instalNo[key]
        result.push({
          label: status,
          value: key
        })
      })
      return result
    }
  },
  props: {
    selectedTty: {
      type: Object,
      default: null
    }
  },
  components: {
    CedBrkCoHelpList,
    TreatyDetHelpList,
    CurrencyHelpList,
    StmtLnTypeHelpList,
    PromptLeave
    // TreatyStmtLine
  },
  mixins: [MessageMixin, treatyAjaxMixin, treatyListMixin]
}
</script>
